var _style, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUnprocessableEntity(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    id: "freepik_stories-date-picker",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    @keyframes fadeIn{0%{opacity:0}to{opacity:1}}@keyframes slideLeft{0%{opacity:0;transform:translateX(-30px)}to{opacity:1;transform:translateX(0)}}@keyframes floating{0%,to{opacity:1;transform:translateY(0)}50%{transform:translateY(-10px)}}@keyframes slideRight{0%{opacity:0;transform:translateX(30px)}to{opacity:1;transform:translateX(0)}}svg#freepik_stories-date-picker:not(.animated) .animable{opacity:0}\n  ")), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-56",
    className: "animable",
    style: {
      transformOrigin: "250px 378.17px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-56",
    cx: 250,
    cy: 378.17,
    rx: 199.97,
    ry: 115.45,
    style: {
      fill: "#fafafa",
      transformOrigin: "250px 378.17px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-56",
    className: "animable",
    style: {
      transformOrigin: "264.752px 371.359px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Shadow--inject-56",
    d: "M183.54 389.8c6.83-6.2 13.7-12.86 22.43-16.28 10.9-4.27 23.21-2.84 34.54.13 4.38 1.15 8.86 2.61 12.19 5.68s5.2 8.17 3.29 12.27c-.47 1-1.45 2.13-.85 3.23a5.57 5.57 0 0 0 2.62 2l6.46 3.15a16.52 16.52 0 0 1 3.66 2.19 5.47 5.47 0 0 1 2 3.66 3.35 3.35 0 0 1-2.08 3.39 2.85 2.85 0 0 1-1.56 2 5.76 5.76 0 0 1-2.53.51 8.29 8.29 0 0 1-2.92-.48 10.61 10.61 0 0 1-2.34-1.62 38.06 38.06 0 0 0-21.88-6.89 3.53 3.53 0 0 1-2.89 4.82c.2 3.92-3.4 6.95-6.92 8.7-7.14 3.53-15.08 4.1-22.81 5a51.61 51.61 0 0 1-16.78-.26c-5.51-1.16-10.83-3.8-14.44-8.11a44.39 44.39 0 0 0-3-3.58 26.08 26.08 0 0 0-3.91-2.82 25.83 25.83 0 0 1-6.88-6.16 12.9 12.9 0 0 1-2.65-8.69 1.14 1.14 0 0 1 .46-1c.52-.27 1.07.3 1.4.78 2.48 3.61 6.76 7.8 11.3 8.59 2.92.5 3.69-.79 5.51-2.6 2.7-2.66 5.78-5.07 8.58-7.61Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "213.078px 396.331px"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-56",
    d: "m426.59 402.07 50.84-29.4a1.18 1.18 0 0 0 0-2.24l-149.7-86.69a4.26 4.26 0 0 0-3.87 0L273 313.14a1.18 1.18 0 0 0 0 2.24l149.71 86.69a4.24 4.24 0 0 0 3.88 0Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "375.215px 342.908px"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.87 443.26c9.08 2.4 18.55 1.19 27.56-1.12 13.3-3.42 27.09-8.69 40.53-2.1 4.47 2.19 8.49 5.42 12.49 8.61s8 6.37 12.54 8.47 9.57 3.11 14.19 1.6c9.35-3.05 11.23-11.06 10.86-19.58a50.79 50.79 0 0 0-3.53-16.14c-8.08-18.41-26.74-22.45-43.35-23.31-18.3-.95-36.45 4.19-53.31 11.48-7.34 3.17-14.61 6.85-20.71 12.42-2.12 1.95-4.17 4.24-5 7.22-1.55 5.78 3.05 11.19 7.73 12.45Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "334.958px 429.51px"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.81 419.06c13.62 7.95 13.62 20.84 0 28.79s-35.71 8-49.33 0-13.62-20.84 0-28.79 35.71-7.95 49.33 0Z",
    style: {
      fill: "#e6e6e6",
      transformOrigin: "86.145px 433.464px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Picture--inject-56",
    className: "animable",
    style: {
      transformOrigin: "435.815px 110.47px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--picture--inject-56",
    className: "animable",
    style: {
      transformOrigin: "435.815px 75.29px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Frame--inject-56",
    className: "animable",
    style: {
      transformOrigin: "435.815px 75.29px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fafafa",
      transformOrigin: "435.8px 94.89px"
    },
    id: "el3yztuoabknq",
    className: "animable",
    d: "m463.75 110.08-1.82 1.08-54.08-31.45 1.82-1.09 54.08 31.46z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      transformOrigin: "435.8px 75.28px"
    },
    id: "elyej46aw3fx",
    className: "animable",
    d: "m409.67 78.62 52.26 30.4v-37.1l-52.26-30.38v37.08z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m404.43 81.68 60.93 35.41V70l-60.93-35.46Zm3.42-41.21 54.08 31.45v39.24l-54.08-31.45Z",
    style: {
      fill: "#f0f0f0",
      transformOrigin: "434.895px 75.815px"
    },
    id: "eli90z2sbc3j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      transformOrigin: "408.76px 60.09px"
    },
    id: "els5zlbnnwecl",
    className: "animable",
    d: "m407.85 79.71 1.82-1.09V41.54l-1.82-1.07v39.24z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fafafa",
      transformOrigin: "435.815px 51.72px"
    },
    id: "el3wwg826w48y",
    className: "animable",
    d: "m404.43 34.54 1.84-1.05 60.93 35.4-1.84 1.06-60.93-35.41z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      transformOrigin: "466.28px 92.99px"
    },
    id: "elu7bp6enx1qg",
    className: "animable",
    d: "m467.2 68.89-1.84 1.06v47.14l1.84-1.06V68.89z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Land--inject-56",
    className: "animable",
    style: {
      transformOrigin: "435.8px 80px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f0f0f0",
      transformOrigin: "435.8px 80px"
    },
    id: "eljsx05444q9n",
    className: "animable",
    d: "m411.05 77.52 49.5 28.8v-9.43L442.83 73.1l-5.09 4.72 1.83 7.9-15.13-32.04-13.39 14.41v9.43z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455 73.78a5.35 5.35 0 0 1 2.43 4.22c0 1.54-1.08 2.16-2.42 1.39a5.34 5.34 0 0 1-2.41-4.18c0-1.57 1.08-2.21 2.4-1.43Z",
    style: {
      fill: "#f0f0f0",
      transformOrigin: "455.015px 76.5842px"
    },
    id: "ell671vso8pds",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "435.815px 145.645px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--frame--inject-56",
    className: "animable",
    style: {
      transformOrigin: "435.815px 145.645px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fafafa",
      transformOrigin: "435.8px 165.245px"
    },
    id: "el8i84uk9s99b",
    className: "animable",
    d: "m463.75 180.43-1.82 1.08-54.08-31.45 1.82-1.08 54.08 31.45z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      transformOrigin: "435.8px 145.635px"
    },
    id: "elzif768yfkxq",
    className: "animable",
    d: "m409.67 148.98 52.26 30.4v-37.1l-52.26-30.39v37.09z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m404.43 152 60.93 35.41V140.3l-60.93-35.4Zm3.42-41.21 54.08 31.45v39.24l-54.08-31.46Z",
    style: {
      fill: "#f0f0f0",
      transformOrigin: "434.895px 146.155px"
    },
    id: "elw4gvo6uj78m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      transformOrigin: "408.76px 130.445px"
    },
    id: "elk9bssaqjyxf",
    className: "animable",
    d: "m407.85 150.06 1.82-1.08v-37.09l-1.82-1.06v39.23z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fafafa",
      transformOrigin: "435.815px 122.07px"
    },
    id: "elvfvw1l1c5k",
    className: "animable",
    d: "m404.43 104.9 1.84-1.06 60.93 35.41-1.84 1.05-60.93-35.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      transformOrigin: "466.28px 163.35px"
    },
    id: "elcb7wa9heiyr",
    className: "animable",
    d: "m467.2 139.25-1.84 1.05v47.15l1.84-1.06v-47.14z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--land--inject-56",
    className: "animable",
    style: {
      transformOrigin: "435.8px 150.355px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f0f0f0",
      transformOrigin: "435.8px 150.355px"
    },
    id: "elw6siq35224q",
    className: "animable",
    d: "m411.05 147.87 49.5 28.81v-9.43l-17.72-23.79-5.09 4.71 1.83 7.91-15.13-32.05-13.39 14.41v9.43z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455 144.14a5.34 5.34 0 0 1 2.42 4.19c0 1.54-1.08 2.16-2.42 1.39a5.34 5.34 0 0 1-2.41-4.18c.01-1.54 1.09-2.17 2.41-1.4Z",
    style: {
      fill: "#f0f0f0",
      transformOrigin: "455.005px 146.931px"
    },
    id: "elkdmvsxqeyaq",
    className: "animable"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-56",
    className: "animable",
    style: {
      transformOrigin: "70.28px 177.921px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-56",
    className: "animable",
    style: {
      transformOrigin: "70.28px 177.921px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "70.28px 173.63px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "70.28px 173.63px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fafafa",
      transformOrigin: "70.295px 283.13px"
    },
    id: "eley7jqn5whb4",
    className: "animable",
    d: "m26.71 306.83 2.49 1.49 84.68-48.89-2.49-1.49-84.68 48.89z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      transformOrigin: "70.295px 173.62px"
    },
    id: "el2e0iwv959nw",
    className: "animable",
    d: "M111.39 257.94 29.2 305.39V89.28l82.19-47.43v216.09z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.58 32.26 24.51 86.57v229.88l94.07-54.31Zm-4.7 227.17L29.2 308.32v-219l84.68-48.89Z",
    style: {
      fill: "#f0f0f0",
      transformOrigin: "71.545px 174.355px"
    },
    id: "elgr74isojl4c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      transformOrigin: "112.635px 149.91px"
    },
    id: "el00ek4hit96v55",
    className: "animable",
    d: "m113.88 259.43-2.49-1.49V41.85l2.49-1.46v219.04z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fafafa",
      transformOrigin: "71.54px 208.325px"
    },
    id: "eljjwuwlzg",
    className: "animable",
    d: "M29.2 230.59v2.92l84.68-48.89-2.49-1.48-82.19 47.45z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fafafa",
      transformOrigin: "71.54px 133.495px"
    },
    id: "eljdmk556vpa9",
    className: "animable",
    d: "M29.2 155.76v2.92l84.68-48.89-2.49-1.48-82.19 47.45z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fafafa",
      transformOrigin: "70.28px 58.69px"
    },
    id: "elqmlzz8gnly",
    className: "animable",
    d: "m118.58 32.26-2.53-1.45-94.07 54.31 2.53 1.45 94.07-54.31z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      transformOrigin: "23.245px 200.785px"
    },
    id: "el4l4z03jixso",
    className: "animable",
    d: "m21.98 85.12 2.53 1.45v229.88l-2.53-1.44V85.12z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      transformOrigin: "66.685px 176.435px"
    },
    id: "elimm8oisuvvq",
    className: "animable",
    d: "m65.42 68.37 2.53-1.46v219.05l-2.53-1.45V68.37z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f0f0f0",
      transformOrigin: "70.3px 175.085px"
    },
    id: "elrms0dck58y",
    className: "animable",
    d: "m72.65 64.21-4.7 2.7v219.05l4.7-2.72V64.21z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f0f0f0",
      transformOrigin: "71.545px 136.945px"
    },
    id: "el4pjeane90pd",
    className: "animable",
    d: "M118.58 107.08v5.42l-94.07 54.31v-5.42l94.07-54.31z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f0f0f0",
      transformOrigin: "71.545px 211.765px"
    },
    id: "el79cr72xtnlv",
    className: "animable",
    d: "M118.58 181.9v5.42l-94.07 54.31v-5.42l94.07-54.31z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fafafa",
      transformOrigin: "48.575px 146.765px"
    },
    id: "el0vhm1mcwlbnr",
    className: "animable",
    d: "m67.95 136.31-2.53-1.46-36.22 20.91v2.92l38.75-22.37z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fafafa",
      transformOrigin: "48.575px 221.565px"
    },
    id: "elpdpo3nwj7sh",
    className: "animable",
    d: "m67.95 211.11-2.53-1.46-36.22 20.91v2.92l38.75-22.37z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Curtains--inject-56",
    className: "animable",
    style: {
      transformOrigin: "67.065px 177.921px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.62 27.08v20.69s-2.83 85.63-62.71 145.6v122a3.25 3.25 0 0 1-4.48 2.63s-1.71 4.19-4.48 2.59c0 0-1.88 4.09-4.48 2.58 0 0-1.93 4.07-4.48 2.59 0 0-1.47 4.33-4.48 2.59V76.22Z",
    style: {
      fill: "#f0f0f0",
      transformOrigin: "67.065px 177.921px"
    },
    id: "elxb9zows53zn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.43 318c-.23-11-.34-22-.43-33l-.13-28.62.13-33 .15-16.51.28-12.11.27 12.11.15 16.51.13 33-.13 28.62c-.09 10.93-.2 21.94-.42 33Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "42.425px 256.38px"
    },
    id: "elsxw12r37lkd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38 320.54c-.23-11-.34-22-.43-33l-.13-28.62.13-33 .16-16.52.27-12.1.27 12.1.15 16.52.13 33-.13 28.62c-.14 10.98-.25 21.99-.42 33Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "37.995px 258.92px"
    },
    id: "elew6i09bs8ha",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.47 323.12c-.23-11-.34-22-.43-33l-.13-28.61.13-33 .16-16.52.27-12.1.27 12.1.15 16.52.13 33-.13 28.61c-.09 10.98-.2 21.99-.42 33Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "33.465px 261.505px"
    },
    id: "elvjpt5vhceob",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 325.71c-.23-11-.34-22-.43-33l-.12-28.62.12-33 .16-16.51.27-12.17.27 12.11.14 16.48.13 33-.13 28.62c-.09 11.07-.2 22.08-.41 33.09Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "28.995px 264.06px"
    },
    id: "elar1tptxe9ka",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.62 47.77c-7 4.3-14 8.48-21.07 12.66L67.34 72.82 46 85l-10.72 6-10.77 5.92L35 90.54l10.56-6.28 21.23-12.39 21.34-12.18c7.14-4.01 14.29-8.02 21.49-11.92Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "67.065px 72.345px"
    },
    id: "elbqrsz7kvn76",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.28 191.51a64.23 64.23 0 0 0 7.15-12.12l1.57-3.17c.51-1.06 1-2.15 1.46-3.21l1.45-3.22 1.38-3.24q5.49-13 10.15-26.31l2.3-6.67 2.15-6.71c.76-2.23 1.38-4.49 2.06-6.74l1-3.38.93-3.4c1.27-4.53 2.38-9.1 3.43-13.68l1.45-6.91q.56-3.48 1.18-7a159.07 159.07 0 0 1-4.39 28 279.86 279.86 0 0 1-8 27.2c-3.17 8.91-6.66 17.71-10.66 26.28l-1.51 3.21-1.59 3.17c-.55 1.05-1.07 2.11-1.63 3.15l-1.72 3.11c-2.44 4.07-4.8 8.27-8.16 11.64Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "62.11px 138.63px"
    },
    id: "el4iz1vfhrkha",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.47 194.41q2.6-5.24 4.8-10.63c.73-1.8 1.48-3.58 2.16-5.4l1-2.72 1-2.73 1-2.73.93-2.76c.63-1.83 1.26-3.66 1.8-5.52s1.2-3.69 1.71-5.56l1.58-5.59c.52-1.86 1-3.75 1.46-5.62l.72-2.82.64-2.83 1.3-5.67 1.13-5.71c.39-1.9.77-3.8 1.07-5.72l1-5.74c.69-3.83 1.1-7.69 1.77-11.54-.08 1.95-.17 3.89-.3 5.84s-.17 3.9-.4 5.84c-.44 3.87-.76 7.77-1.44 11.62a204.34 204.34 0 0 1-4.81 22.93 198.53 198.53 0 0 1-7.53 22.2 128.58 128.58 0 0 1-10.59 20.86Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "46.005px 149.765px"
    },
    id: "el75kajeskmkr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 195.16c1-8.24 1.94-16.47 2.83-24.7s1.63-16.46 2.27-24.72l.48-6.19.39-6.19c.28-4.13.44-8.26.64-12.39s.32-8.27.37-12.41 0-8.28.14-12.44A232.38 232.38 0 0 1 37.33 121q-.06 12.46-1 24.9c-.68 8.28-1.57 16.54-2.78 24.76s-2.69 16.41-4.55 24.5Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "33.1665px 145.64px"
    },
    id: "el65lirdhgb6k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.14 29.67a83.47 83.47 0 0 1 .55 10.33 83.42 83.42 0 0 1-.55 10.34 87.48 87.48 0 0 1-.55-10.34 87.54 87.54 0 0 1 .55-10.33Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "105.141px 40.005px"
    },
    id: "eleb2k6w4i8s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.66 32.26a83.21 83.21 0 0 1 .55 10.34 83.47 83.47 0 0 1-.55 10.4 87.54 87.54 0 0 1-.55-10.35 87.26 87.26 0 0 1 .55-10.39Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "100.661px 42.63px"
    },
    id: "elv7gkwqq89m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.18 34.84a83.47 83.47 0 0 1 .55 10.35 83.21 83.21 0 0 1-.55 10.34 87.26 87.26 0 0 1-.55-10.34 87.54 87.54 0 0 1 .55-10.35Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "96.1809px 45.185px"
    },
    id: "elmbbdnrvptu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.7 37.43a83.42 83.42 0 0 1 .55 10.34 83.47 83.47 0 0 1-.55 10.35 87.54 87.54 0 0 1-.55-10.35 87.48 87.48 0 0 1 .55-10.34Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "91.7009px 47.775px"
    },
    id: "elfhz91s8145e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.22 40a83.21 83.21 0 0 1 .55 10.34 83.47 83.47 0 0 1-.55 10.35 87.54 87.54 0 0 1-.55-10.35A87.26 87.26 0 0 1 87.22 40Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "87.2209px 50.345px"
    },
    id: "el4q6jq0zp36c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.74 42.6a83.47 83.47 0 0 1 .55 10.4 83.21 83.21 0 0 1-.55 10.34A87.26 87.26 0 0 1 82.19 53a87.54 87.54 0 0 1 .55-10.4Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "82.7409px 52.97px"
    },
    id: "ellkqtk38fdj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.26 45.19a83.42 83.42 0 0 1 .55 10.34 83.47 83.47 0 0 1-.55 10.35 87.54 87.54 0 0 1-.55-10.35 87.48 87.48 0 0 1 .55-10.34Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "78.2609px 55.535px"
    },
    id: "elhycaqc7vzl8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.78 47.78a83.21 83.21 0 0 1 .55 10.34 83.47 83.47 0 0 1-.55 10.35 87.54 87.54 0 0 1-.55-10.35 87.26 87.26 0 0 1 .55-10.34Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "73.7809px 58.125px"
    },
    id: "elvmd76r6xaaa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3 50.36a83.47 83.47 0 0 1 .55 10.35 83.31 83.31 0 0 1-.55 10.34 87.37 87.37 0 0 1-.55-10.34 87.54 87.54 0 0 1 .55-10.35Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "69.3009px 60.705px"
    },
    id: "elikumwebdlo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.82 53a85.4 85.4 0 0 1 .55 10.34 83.47 83.47 0 0 1-.55 10.35 87.54 87.54 0 0 1-.55-10.35A87.48 87.48 0 0 1 64.82 53Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "64.8209px 63.345px"
    },
    id: "elziacmm1mxb9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.34 55.54a87.26 87.26 0 0 1 .55 10.34 83.47 83.47 0 0 1-.55 10.35 85.46 85.46 0 0 1-.55-10.35 87.26 87.26 0 0 1 .55-10.34Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "60.3405px 65.885px"
    },
    id: "elmj24x1etd3c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.86 58.12a87.54 87.54 0 0 1 .55 10.35 83.31 83.31 0 0 1-.55 10.34 85.29 85.29 0 0 1-.55-10.34 87.54 87.54 0 0 1 .55-10.35Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "55.8605px 68.465px"
    },
    id: "elm60j8ceinhq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.38 60.71a87.48 87.48 0 0 1 .55 10.34 83.47 83.47 0 0 1-.55 10.35 85.46 85.46 0 0 1-.55-10.35 87.48 87.48 0 0 1 .55-10.34Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "51.3805px 71.055px"
    },
    id: "elphz6xv6mccs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9 63.3a87.26 87.26 0 0 1 .55 10.34A83.47 83.47 0 0 1 46.9 84a85.46 85.46 0 0 1-.55-10.35 87.26 87.26 0 0 1 .55-10.35Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "46.9005px 73.65px"
    },
    id: "elnk7d5n9uqjf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.42 65.88A87.54 87.54 0 0 1 43 76.23a83.31 83.31 0 0 1-.55 10.34 85.29 85.29 0 0 1-.55-10.34 87.54 87.54 0 0 1 .52-10.35Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "42.4499px 76.225px"
    },
    id: "el9iax0n5rr7f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.94 68.47a87.48 87.48 0 0 1 .55 10.34 83.47 83.47 0 0 1-.55 10.35 83.47 83.47 0 0 1-.55-10.35 87.48 87.48 0 0 1 .55-10.34Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "37.94px 78.815px"
    },
    id: "el7tf1is3qnwj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.46 71.05A87.54 87.54 0 0 1 34 81.4a83.47 83.47 0 0 1-.55 10.35 83.47 83.47 0 0 1-.55-10.35 87.54 87.54 0 0 1 .56-10.35Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "33.45px 81.4px"
    },
    id: "elvnr3q4h2it9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 73.64A87.54 87.54 0 0 1 29.53 84 83.31 83.31 0 0 1 29 94.33 83.31 83.31 0 0 1 28.43 84 87.54 87.54 0 0 1 29 73.64Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "28.9814px 83.985px"
    },
    id: "el9156znd5d7i",
    className: "animable"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Furniture--inject-56",
    className: "animable",
    style: {
      transformOrigin: "379.78px 284.02px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Drawer--inject-56",
    className: "animable",
    style: {
      transformOrigin: "379.78px 284.02px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "423.86px 377.26px"
    },
    id: "el2nmmiufmd45",
    className: "animable",
    d: "m413.89 366.18 5.06 25.08 4.91 2.84 4.88-2.81 5.09-25.11-9.97-5.76-9.97 5.76z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      opacity: 0.55,
      transformOrigin: "423.86px 377.26px"
    },
    className: "animable",
    d: "m413.89 366.18 5.06 25.08 4.91 2.84 4.88-2.81 5.09-25.11-9.97-5.76-9.97 5.76z",
    id: "elil8ytthdz6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "418.875px 380.14px"
    },
    id: "elryry3gi2nup",
    className: "animable",
    d: "M423.86 394.1v-22.16l-9.97-5.76 5.06 25.08 4.91 2.84z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      opacity: 0.7,
      transformOrigin: "418.875px 380.14px"
    },
    className: "animable",
    d: "M423.86 394.1v-22.16l-9.97-5.76 5.06 25.08 4.91 2.84z",
    id: "elyrevyvkujdb"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "462.84px 354.76px"
    },
    id: "el7ome5gynufr",
    className: "animable",
    d: "m452.87 343.68 5.05 25.08 4.92 2.84 4.87-2.81 5.1-25.11-9.97-5.76-9.97 5.76z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      opacity: 0.55,
      transformOrigin: "462.84px 354.76px"
    },
    className: "animable",
    d: "m452.87 343.68 5.05 25.08 4.92 2.84 4.87-2.81 5.1-25.11-9.97-5.76-9.97 5.76z",
    id: "elehi00rwepia"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "457.855px 357.64px"
    },
    id: "elsxsbbx6dvpl",
    className: "animable",
    d: "M462.84 371.6v-22.16l-9.97-5.76 5.05 25.08 4.92 2.84z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      opacity: 0.7,
      transformOrigin: "457.855px 357.64px"
    },
    className: "animable",
    d: "M462.84 371.6v-22.16l-9.97-5.76 5.05 25.08 4.92 2.84z",
    id: "el6n7gyl5up7g"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "294.16px 302.375px"
    },
    id: "el16j7ct8qd2c",
    className: "animable",
    d: "m284.19 291.29 5.05 25.09 4.92 2.83 4.87-2.81 5.1-25.11-9.97-5.75-9.97 5.75z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      opacity: 0.55,
      transformOrigin: "294.16px 302.375px"
    },
    className: "animable",
    d: "m284.19 291.29 5.05 25.09 4.92 2.83 4.87-2.81 5.1-25.11-9.97-5.75-9.97 5.75z",
    id: "el17mflotmj7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "289.175px 305.25px"
    },
    id: "eldojatw62mya",
    className: "animable",
    d: "M294.16 319.21v-22.16l-9.97-5.76 5.05 25.09 4.92 2.83z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      opacity: 0.7,
      transformOrigin: "289.175px 305.25px"
    },
    className: "animable",
    d: "M294.16 319.21v-22.16l-9.97-5.76 5.05 25.09 4.92 2.83z",
    id: "elzhht9mdz51"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      transformOrigin: "378.5px 333.055px"
    },
    className: "animable",
    id: "elhdfisgoe1v5"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "294.16px 295.61px"
    },
    id: "el1ym2boxuyv8",
    className: "animable",
    d: "m304.13 291.29-9.97-5.75-9.97 5.75 1.96 9.77 8.01 4.62 7.98-4.62 1.99-9.77z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "462.84px 347.995px"
    },
    id: "elzmhhydqj8d",
    className: "animable",
    d: "m452.87 343.68 1.97 9.78 8 4.61 7.98-4.61 1.99-9.78-9.97-5.76-9.97 5.76z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "423.86px 370.495px"
    },
    id: "ele1e29bpdzzu",
    className: "animable",
    d: "m431.85 375.96 1.98-9.78-9.97-5.76-9.97 5.76 1.97 9.77 8 4.62 7.99-4.61z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Cabinet--inject-56",
    className: "animable",
    style: {
      transformOrigin: "379.78px 274.065px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--cabinet--inject-56",
    className: "animable",
    style: {
      transformOrigin: "379.78px 274.065px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "451.03px 315.205px"
    },
    id: "elanwtjhhtl5a",
    className: "animable",
    d: "m423.86 374.19 54.34-31.37v-86.6l-54.34 31.37v86.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      opacity: 0.7,
      transformOrigin: "451.03px 315.205px"
    },
    className: "animable",
    d: "m423.86 374.19 54.34-31.37v-86.6l-54.34 31.37v86.6z",
    id: "elvghjs6adija"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "352.61px 289.755px"
    },
    id: "elg4pqtta7y0k",
    className: "animable",
    d: "m423.86 287.59-142.5-82.27v86.6l142.5 82.27v-86.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      opacity: 0.8,
      transformOrigin: "352.61px 289.755px"
    },
    className: "animable",
    d: "m423.86 287.59-142.5-82.27v86.6l142.5 82.27v-86.6z",
    id: "elllhp4exfkll"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "379.78px 230.765px"
    },
    id: "elwx62lfyzh1",
    className: "animable",
    d: "m281.36 205.32 142.5 82.27 54.34-31.37-142.5-82.28-54.34 31.38z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      opacity: 0.9,
      transformOrigin: "379.78px 230.765px"
    },
    className: "animable",
    d: "m281.36 205.32 142.5 82.27 54.34-31.37-142.5-82.28-54.34 31.38z",
    id: "elykt2h45y9go"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4,
      transformOrigin: "386.635px 310.38px"
    },
    className: "animable",
    id: "el2x4nogh5wh2"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "386.635px 310.38px"
    },
    id: "el9p92uahha2s",
    className: "animable",
    d: "m416.1 293.74-57.52-33.23.01 65.69-1.43.83 57.52 33.22 1.43-.83-.01-65.68z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "385.92px 310.795px"
    },
    id: "eltmf94giqu6p",
    className: "animable",
    d: "m414.68 294.56-57.52-33.22v65.69l57.52 33.22v-65.69z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.85,
      transformOrigin: "385.92px 310.795px"
    },
    className: "animable",
    id: "elel5v18lidg"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      transformOrigin: "385.92px 310.795px"
    },
    id: "elewfp84e0goe",
    className: "animable",
    d: "m414.68 294.56-57.52-33.22v65.69l57.52 33.22v-65.69z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M367 280.49v12.19c0 1.58-.87 2.37-1.94 1.75a5 5 0 0 1-1.94-4v-12.2c0-1.58.87-2.36 1.94-1.74a5 5 0 0 1 1.94 4Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "365.06px 285.459px"
    },
    id: "elqhj390boq6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4,
      transformOrigin: "321.23px 272.615px"
    },
    className: "animable",
    id: "eldr6vkq8d63"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "321.23px 272.615px"
    },
    id: "elvstza8h7jqb",
    className: "animable",
    d: "m350.7 255.97-57.52-33.22.01 65.68-1.43.83 57.52 33.22 1.42-.83v-65.68z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "320.52px 273.025px"
    },
    id: "el6shkik4s8yl",
    className: "animable",
    d: "m349.27 256.79-57.51-33.22v65.69l57.52 33.22-.01-65.69z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.85,
      transformOrigin: "320.52px 273.025px"
    },
    className: "animable",
    id: "el8bd263gufli"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      transformOrigin: "320.52px 273.025px"
    },
    id: "el0lrv1f3nbqh",
    className: "animable",
    d: "m349.27 256.79-57.51-33.22v65.69l57.52 33.22-.01-65.69z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M343 266.65v12.19c0 1.59-.87 2.37-1.94 1.75a5 5 0 0 1-1.94-4v-12.18c0-1.59.87-2.37 1.94-1.75a5 5 0 0 1 1.94 3.99Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "341.06px 271.625px"
    },
    id: "el81wqz2dv2xx",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pot--inject-56",
    className: "animable",
    style: {
      transformOrigin: "433.101px 241.733px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      transformOrigin: "433.334px 259.364px"
    },
    className: "animable",
    id: "elukcizksvoyi"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M421.4 252.47c-6.58 3.81-6.58 10 0 13.78s17.27 3.8 23.86 0 6.59-10 0-13.77-17.26-3.81-23.86-.01Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "433.334px 259.364px"
    },
    id: "eln35r6lhhq6",
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M443.82 260.21c5.74-5.85 9.11-20.47 3.51-25.11h-28.47c-5.59 4.64-2.22 19.25 3.51 25.1l.16.17.19.19.52.46.14.11.43.33c.25.17.49.33.74.47 4.72 2.72 12.37 2.72 17.09 0a6.77 6.77 0 0 0 .75-.48l.4-.3.21-.15a5.41 5.41 0 0 0 .5-.44l.23-.22Z",
    style: {
      fill: "#ebebeb",
      transformOrigin: "433.098px 249.535px"
    },
    id: "elt9o0pl2nv7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.34 233.23c-6.5 3.75-6.5 9.83 0 13.58s17 3.75 23.52 0 6.5-9.83 0-13.58-17.03-3.75-23.52 0Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "433.104px 240.02px"
    },
    id: "elk5ebqbh2zy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.94 235.89c-3.95 2.28-3.95 6 0 8.26a15.82 15.82 0 0 0 14.31 0c4-2.28 4-6 0-8.26a15.82 15.82 0 0 0-14.31 0Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "433.114px 240.02px"
    },
    id: "elepii8zb9nes",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.25 239.81a15.82 15.82 0 0 0-14.31 0 6.55 6.55 0 0 0-2.37 2.17 6.55 6.55 0 0 0 2.37 2.17 15.82 15.82 0 0 0 14.31 0 6.55 6.55 0 0 0 2.37-2.17 6.55 6.55 0 0 0-2.37-2.17Z",
    style: {
      fill: "#37474f",
      transformOrigin: "433.095px 241.98px"
    },
    id: "elmki6bfeyq9l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.81 242a32.76 32.76 0 0 1-5.17-6.88c-2.39-4.23-2.83-9.89-1.6-10.59s6.27 5 6.27 5a30.69 30.69 0 0 1-.53-7.22c.21-3.76 1.13-7.18 2.2-7.87s3.5 4.06 4.53 7.5 1.65 6.27 1.65 6.27a53.42 53.42 0 0 1 1.86-7.92c1.25-3.57 2.39-4.38 3.27-4s1.47 2 1.73 6.78a46.71 46.71 0 0 1-.22 6.81s1.78-1.95 3.75-3.84c2.16-2.08 3.08-2.36 3.7-2s.79 3.63-2.56 9.69a33.79 33.79 0 0 1-6.32 8.32s-4.64 2.95-12.56-.05Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "433.99px 228.859px"
    },
    id: "ellx7h9sukdts",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      transformOrigin: "433.99px 228.859px"
    },
    className: "animable",
    id: "elq7rzuj6tn0m"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M426.81 242a32.76 32.76 0 0 1-5.17-6.88c-2.39-4.23-2.83-9.89-1.6-10.59s6.27 5 6.27 5a30.69 30.69 0 0 1-.53-7.22c.21-3.76 1.13-7.18 2.2-7.87s3.5 4.06 4.53 7.5 1.65 6.27 1.65 6.27a53.42 53.42 0 0 1 1.86-7.92c1.25-3.57 2.39-4.38 3.27-4s1.47 2 1.73 6.78a46.71 46.71 0 0 1-.22 6.81s1.78-1.95 3.75-3.84c2.16-2.08 3.08-2.36 3.7-2s.79 3.63-2.56 9.69a33.79 33.79 0 0 1-6.32 8.32s-4.64 2.95-12.56-.05Z",
    id: "elpav0y3akk0s",
    className: "animable",
    style: {
      transformOrigin: "433.99px 228.859px"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Calendar--inject-56",
    className: "animable",
    style: {
      transformOrigin: "196.65px 180.989px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) slideLeft,1.5s Infinite linear floating",
      animationDelay: "0s,1s"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Tab--inject-56",
    className: "animable",
    style: {
      transformOrigin: "182.76px 174.88px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M174 67.16v-11.9a4.16 4.16 0 0 1 1.85-3.26L229 21.35c1-.59 1.87-.11 1.87 1.08v11.91c0 1.19.84 1.67 1.87 1.08l30.7-17.75c1-.6 1.87-.12 1.87 1.08v216.93a4.16 4.16 0 0 1-1.87 3.25l-161.36 93.16c-1 .6-1.87.12-1.87-1.08V114.08a3.89 3.89 0 0 1 1.91-3.16l70-36.46c1.02-.6 1.88-6.11 1.88-7.3Z",
    style: {
      fill: "#455a64",
      transformOrigin: "182.76px 174.88px"
    },
    id: "elpz3r08rsw4g",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "199.365px 187.173px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.44 339.9V142.21a13.81 13.81 0 0 1 2-6.8l-8.72-5a14.11 14.11 0 0 0-2.08 6.85v197.6a4.57 4.57 0 0 0 2.63 4.18c-.82-.46.15.1.24.15s6.76 3.91 8.16 4.71a4.56 4.56 0 0 1-2.23-4Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "111.155px 237.155px"
    },
    id: "elohvwlv8b21",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m286.26 35.62-165 94.72a14.17 14.17 0 0 0-4.82 5.09l-8.7-5a13.67 13.67 0 0 1 4.76-5l165-94.73c2-1.14 3.7-1.16 5-.4s6.92 4 8.36 4.76c-1.22-.62-2.86-.45-4.6.56Z",
    style: {
      fill: "#f0f0f0",
      transformOrigin: "199.3px 82.6044px"
    },
    id: "el4oje01lih9q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m148.19 115.06-6.25-7.38a2.25 2.25 0 0 0-.91-1c-1.2-.71-8.49-4.88-8.88-5.1a2.31 2.31 0 0 0-3.38 1.34l-7 17.24 8.86 5.09Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "134.98px 113.257px"
    },
    id: "elfi03f9vgrmb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.13 344.11a4.23 4.23 0 0 1-4.23-4.21V142.21a14.65 14.65 0 0 1 6.63-11.46l9.38-5.39a.51.51 0 0 0 .19-.22l7-17a1.84 1.84 0 0 1 1.79-1.36 1.82 1.82 0 0 1 1.67 1.08.41.41 0 0 0 .07.11l6.19 7.25a.44.44 0 0 0 .35.16.46.46 0 0 0 .23-.06L286.51 36a5.75 5.75 0 0 1 2.8-.87 3 3 0 0 1 1.34.29 2.67 2.67 0 0 1 .54.3c1.37.9 1.48 2.45 1.48 3.83v197.67a14.64 14.64 0 0 1-6.67 11.46l-153.75 88.37-11.19 6.59a4.17 4.17 0 0 1-1.93.47Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "203.785px 189.62px"
    },
    id: "elr0v3dhcvlb7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.31 35.61a2.66 2.66 0 0 1 1.16.25 2.46 2.46 0 0 1 .44.25c1 .69 1.25 1.82 1.25 3.43v197.68a14.13 14.13 0 0 1-6.4 11.06L132 336.65l-11.13 6.56a3.72 3.72 0 0 1-1.73.43 3.78 3.78 0 0 1-3.77-3.75V142.21a14.36 14.36 0 0 1 6.39-11.06l9.38-5.39a1 1 0 0 0 .39-.45l7-17a.16.16 0 0 0 0-.09 1.35 1.35 0 0 1 1.34-1 1.34 1.34 0 0 1 1.25.81.7.7 0 0 0 .14.21l6.19 7.25a.93.93 0 0 0 .7.33.84.84 0 0 0 .46-.13l138.12-79.27a5.36 5.36 0 0 1 2.58-.81m0-.93a6.21 6.21 0 0 0-3 .94l-138.18 79.31-6.19-7.25a2.31 2.31 0 0 0-4.31.3l-7 17-9.37 5.38a15.18 15.18 0 0 0-6.86 11.87V339.9a4.69 4.69 0 0 0 6.85 4.14l11.19-6.59 153.8-88.36a15.18 15.18 0 0 0 6.85-11.87V39.57c0-1.45-.12-3.18-1.66-4.2a3.79 3.79 0 0 0-.62-.35 3.58 3.58 0 0 0-1.54-.34Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "203.745px 189.624px"
    },
    id: "el0n1zu0yfcwb",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--calendar--inject-56",
    className: "animable",
    style: {
      transformOrigin: "203.768px 189.306px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M180 225.42c3.9-2.25 7.07-.42 7.07 4.09a15.65 15.65 0 0 1-7.07 12.25c-3.91 2.25-7.08.42-7.08-4.09a15.64 15.64 0 0 1 7.08-12.25Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "179.995px 233.59px"
    },
    id: "elz2kz01buji",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m275.32 145.75-71.16 41a15.65 15.65 0 0 0-7.07 12.25c0 4.51 3.17 6.34 7.07 4.08l71.15-41a15.62 15.62 0 0 0 7.08-12.25c.01-4.51-3.16-6.34-7.07-4.08Z",
    style: {
      fill: "#b0bec5",
      opacity: 0.2,
      transformOrigin: "239.74px 174.415px"
    },
    className: "animable",
    id: "eln8o5960925"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m180 225.42-48 27.71a15.6 15.6 0 0 0-7 12.25c0 4.51 3.16 6.33 7.07 4.08l47.93-27.7a15.65 15.65 0 0 0 7-12.25c0-4.51-3.13-6.34-7-4.09Z",
    style: {
      fill: "#b0bec5",
      opacity: 0.2,
      transformOrigin: "156px 247.441px"
    },
    className: "animable",
    id: "el23uexgdjp3u"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.16 186.77c3.91-2.25 7.08-.43 7.08 4.08a15.62 15.62 0 0 1-7.08 12.25c-3.9 2.26-7.07.43-7.07-4.08a15.65 15.65 0 0 1 7.07-12.25Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "204.165px 194.937px"
    },
    id: "elty92esdl7ch",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.05 214.58a.54.54 0 0 1-.06.25.41.41 0 0 1-.14.17l-.3.17a.1.1 0 0 1-.14 0 .22.22 0 0 1-.06-.18v-6.19l-1.18 2.06a.26.26 0 0 1-.15.16.13.13 0 0 1-.13 0l-.17-.25a.24.24 0 0 1 0-.2.48.48 0 0 1 .07-.24l1.57-2.75a.37.37 0 0 1 .11-.15l.12-.08.3-.17a.11.11 0 0 1 .14 0 .24.24 0 0 1 .06.18Z",
    style: {
      fill: "#455a64",
      transformOrigin: "131.895px 211.177px"
    },
    id: "elk85bf5wj6g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.45 197.23a3.84 3.84 0 0 0 .33-.81 2.9 2.9 0 0 0 .11-.88 1.31 1.31 0 0 0-.22-.86c-.15-.18-.39-.18-.72 0a1.68 1.68 0 0 0-.43.36 2.22 2.22 0 0 0-.3.49 2.55 2.55 0 0 0-.19.55c-.05.2-.09.4-.12.59a.84.84 0 0 1-.07.24.38.38 0 0 1-.12.13l-.33.19a.09.09 0 0 1-.12 0 .21.21 0 0 1 0-.15 3.86 3.86 0 0 1 .12-.91 4.86 4.86 0 0 1 .34-1 4.19 4.19 0 0 1 .53-.89 2.74 2.74 0 0 1 .73-.64 1.29 1.29 0 0 1 .71-.22.75.75 0 0 1 .51.22 1.32 1.32 0 0 1 .31.59 3.23 3.23 0 0 1 .11.87v.67a3.5 3.5 0 0 1-.12.63 6.08 6.08 0 0 1-.22.64 6.74 6.74 0 0 1-.32.69l-1.63 3.28 2.24-1.29a.1.1 0 0 1 .14 0 .21.21 0 0 1 .06.17v.41a.57.57 0 0 1-.06.25.41.41 0 0 1-.14.17l-3.15 1.81a.11.11 0 0 1-.14 0 .24.24 0 0 1-.06-.18V202a.85.85 0 0 1 0-.23 1.65 1.65 0 0 1 .13-.29Z",
    style: {
      fill: "#455a64",
      transformOrigin: "156.002px 197.988px"
    },
    id: "elvj2kwuvb0os",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.62 186.67a1.33 1.33 0 0 0 .11.3.36.36 0 0 0 .19.21.65.65 0 0 0 .35 0 1.78 1.78 0 0 0 .56-.23 2.6 2.6 0 0 0 .43-.33 3 3 0 0 0 .36-.48 2.53 2.53 0 0 0 .33-1.27 1.39 1.39 0 0 0-.09-.56.42.42 0 0 0-.23-.27.55.55 0 0 0-.36 0 1.46 1.46 0 0 0-.44.19l-.61.35a.12.12 0 0 1-.14 0 .24.24 0 0 1-.06-.18v-.4a.78.78 0 0 1 0-.21c0-.07.06-.13.08-.19l1.32-2.94-2.11 1.21a.11.11 0 0 1-.14 0 .24.24 0 0 1-.06-.18v-.4a.54.54 0 0 1 .06-.25.41.41 0 0 1 .14-.17l2.88-1.66a.11.11 0 0 1 .14 0 .22.22 0 0 1 .06.18v.4a.93.93 0 0 1 0 .22 2.34 2.34 0 0 1-.09.24l-1.3 2.89a1.66 1.66 0 0 1 .67-.21.83.83 0 0 1 .52.16 1.12 1.12 0 0 1 .33.53 2.48 2.48 0 0 1 .13.88 4.13 4.13 0 0 1-.15 1.11 4.86 4.86 0 0 1-.39 1 4 4 0 0 1-.58.81 2.67 2.67 0 0 1-.7.58 2.11 2.11 0 0 1-.85.31.83.83 0 0 1-.92-.56 1.73 1.73 0 0 1-.12-.66.48.48 0 0 1 0-.2.28.28 0 0 1 .12-.14l.33-.19h.13a.23.23 0 0 1 .1.11Z",
    style: {
      fill: "#455a64",
      transformOrigin: "179.79px 183.753px"
    },
    id: "ela149ot2udxl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.36 173.71a.11.11 0 0 1-.14 0 .24.24 0 0 1-.06-.18V172l-2.29 1.32a.11.11 0 0 1-.14 0 .23.23 0 0 1-.06-.18v-.4a.88.88 0 0 1 0-.2 1.13 1.13 0 0 1 .08-.24l2.3-6a2.29 2.29 0 0 1 .13-.27.41.41 0 0 1 .16-.16l.29-.17a.11.11 0 0 1 .14 0 .22.22 0 0 1 .06.18v4.7l.63-.37a.1.1 0 0 1 .13 0 .24.24 0 0 1 .06.18v.41a.61.61 0 0 1-.06.25.4.4 0 0 1-.13.17l-.63.36v1.55a.57.57 0 0 1-.06.25.41.41 0 0 1-.14.17Zm-.2-2.75v-3.17l-1.58 4.08Z",
    style: {
      fill: "#455a64",
      transformOrigin: "203.658px 169.705px"
    },
    id: "elb6oezko0uh9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.4 159a.71.71 0 0 0 .42.59.8.8 0 0 0 .74-.12 1.87 1.87 0 0 0 .45-.36 2.08 2.08 0 0 0 .37-.51 2.74 2.74 0 0 0 .25-.66 3.19 3.19 0 0 0 .09-.77 2 2 0 0 0-.09-.66.74.74 0 0 0-.25-.37.55.55 0 0 0-.38-.14 1.29 1.29 0 0 0-.45.16 2.05 2.05 0 0 0-.44.35 3.36 3.36 0 0 0-.27.36l-.19.31a.56.56 0 0 1-.19.21l-.38.22a.09.09 0 0 1-.11 0 .21.21 0 0 1 0-.15l.22-3.88a.61.61 0 0 1 .06-.25.41.41 0 0 1 .14-.17l2.58-1.48a.11.11 0 0 1 .14 0 .24.24 0 0 1 .05.18v.41a.59.59 0 0 1-.05.25.41.41 0 0 1-.14.17l-2.13 1.22-.11 2a2.59 2.59 0 0 1 .33-.37 3.44 3.44 0 0 1 .54-.4 1.51 1.51 0 0 1 .72-.23.87.87 0 0 1 .59.18 1.29 1.29 0 0 1 .4.6 3 3 0 0 1 .15 1 4.62 4.62 0 0 1-.15 1.19 5 5 0 0 1-.4 1.07 4.09 4.09 0 0 1-.59.86 3.28 3.28 0 0 1-.72.6 1.67 1.67 0 0 1-.7.24.92.92 0 0 1-1-.56 1.73 1.73 0 0 1-.17-.78.53.53 0 0 1 0-.2.28.28 0 0 1 .12-.14l.33-.19a.11.11 0 0 1 .11 0 .16.16 0 0 1 .11.22Z",
    style: {
      fill: "#455a64",
      transformOrigin: "227.591px 156.158px"
    },
    id: "elkdroou6aiy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m251.22 141.41.13-.11a.53.53 0 0 1 .14-.1 1.47 1.47 0 0 1 .75-.23.93.93 0 0 1 .6.23 1.41 1.41 0 0 1 .39.63 3 3 0 0 1 .15 1 4.6 4.6 0 0 1-.15 1.15 5 5 0 0 1-.39 1.09 4.86 4.86 0 0 1-.6.92 3 3 0 0 1-.75.64 1.53 1.53 0 0 1-.76.23.93.93 0 0 1-.6-.23 1.41 1.41 0 0 1-.39-.63 3 3 0 0 1-.15-1 4.34 4.34 0 0 1 0-.63 5.29 5.29 0 0 1 .13-.6 4.74 4.74 0 0 1 .17-.57c.06-.19.12-.37.19-.54l1.33-3.78.08-.19a.33.33 0 0 1 .14-.17l.42-.24a.09.09 0 0 1 .11 0 .34.34 0 0 1 0 .16.24.24 0 0 1 0 .09.14.14 0 0 1 0 .07Zm-.93 3.19a2.05 2.05 0 0 0 .08.59 1.09 1.09 0 0 0 .24.41.63.63 0 0 0 .38.16 1 1 0 0 0 .5-.15 2 2 0 0 0 .5-.43 3.25 3.25 0 0 0 .37-.59 4.23 4.23 0 0 0 .24-.68 2.82 2.82 0 0 0 .08-.69 1.76 1.76 0 0 0-.08-.59 1.09 1.09 0 0 0-.24-.41.62.62 0 0 0-.37-.16 1.05 1.05 0 0 0-.5.15 1.71 1.71 0 0 0-.5.43 2.65 2.65 0 0 0-.38.6 3.81 3.81 0 0 0-.24.67 3.4 3.4 0 0 0-.08.69Z",
    style: {
      fill: "#455a64",
      transformOrigin: "251.48px 142.561px"
    },
    id: "el7lk0g32bvfh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.82 124a.09.09 0 0 1 .13 0 .24.24 0 0 1 .06.18v.4a2 2 0 0 1 0 .23 1.47 1.47 0 0 1-.06.27l-1.62 7.38a1 1 0 0 1-.08.23.3.3 0 0 1-.13.16l-.34.2a.1.1 0 0 1-.12 0 .23.23 0 0 1-.05-.16v-.06a.51.51 0 0 1 0-.09l1.63-7.39-2.4 1.38a.11.11 0 0 1-.14 0 .3.3 0 0 1-.05-.18v-.41a.69.69 0 0 1 .05-.24.35.35 0 0 1 .14-.17Z",
    style: {
      fill: "#455a64",
      transformOrigin: "275.332px 128.521px"
    },
    id: "ele13l2lz3fyt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.22 239.26a4.06 4.06 0 0 1 .18-1.17 5 5 0 0 1 .52-1.12 1 1 0 0 1-.42-.49 2.07 2.07 0 0 1-.15-.84 3.86 3.86 0 0 1 .13-.93 4.79 4.79 0 0 1 .36-.91 4.66 4.66 0 0 1 .53-.78 2.7 2.7 0 0 1 .68-.56 1.39 1.39 0 0 1 .67-.22.89.89 0 0 1 .54.16 1 1 0 0 1 .36.5 2.06 2.06 0 0 1 .13.78 3.34 3.34 0 0 1-.16 1 4 4 0 0 1-.42 1 1 1 0 0 1 .52.52 2.06 2.06 0 0 1 .19.95 3.79 3.79 0 0 1-.13 1 4.77 4.77 0 0 1-.38 1 4.63 4.63 0 0 1-.58.84 3 3 0 0 1-.74.61 1.49 1.49 0 0 1-.74.24.89.89 0 0 1-.58-.17 1.14 1.14 0 0 1-.38-.53 2.3 2.3 0 0 1-.13-.88Zm.69-.4a1.28 1.28 0 0 0 .08.47.64.64 0 0 0 .24.29.59.59 0 0 0 .35.08 1.09 1.09 0 0 0 .47-.16 2.26 2.26 0 0 0 .46-.37 2.87 2.87 0 0 0 .36-.5 2.28 2.28 0 0 0 .23-.56 1.88 1.88 0 0 0 .09-.57 1.13 1.13 0 0 0-.09-.47.57.57 0 0 0-.23-.29.6.6 0 0 0-.36-.08 1.15 1.15 0 0 0-.46.16 2.12 2.12 0 0 0-.47.38 2.9 2.9 0 0 0-.35.49 2.78 2.78 0 0 0-.24.56 2.24 2.24 0 0 0-.08.57Zm.14-3.62a.93.93 0 0 0 .08.42.48.48 0 0 0 .21.25.46.46 0 0 0 .31.07.82.82 0 0 0 .4-.13 1.94 1.94 0 0 0 .4-.32 3.28 3.28 0 0 0 .32-.44 2.41 2.41 0 0 0 .21-.5 1.92 1.92 0 0 0 .08-.51 1.1 1.1 0 0 0-.08-.43.53.53 0 0 0-.21-.25.66.66 0 0 0-.32-.07 1 1 0 0 0-.4.14 1.94 1.94 0 0 0-.4.32 2.32 2.32 0 0 0-.31.44 2 2 0 0 0-.21.5 1.51 1.51 0 0 0-.08.51Z",
    style: {
      fill: "#455a64",
      transformOrigin: "132.05px 236.541px"
    },
    id: "elnl3yra5upvj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m156.11 223.85-.1.07-.1.06a1.43 1.43 0 0 1-.68.22.9.9 0 0 1-.58-.17 1.3 1.3 0 0 1-.41-.6 2.77 2.77 0 0 1-.16-1 4.94 4.94 0 0 1 .14-1.14 5.25 5.25 0 0 1 .4-1.07 4.3 4.3 0 0 1 .59-.89 2.46 2.46 0 0 1 .7-.61 1.48 1.48 0 0 1 .76-.24.85.85 0 0 1 .58.22 1.48 1.48 0 0 1 .37.63 3.5 3.5 0 0 1 .12 1 4.28 4.28 0 0 1-.05.6c0 .22-.09.43-.15.64s-.12.43-.19.63l-.19.56-1.33 3.78-.08.19a.35.35 0 0 1-.15.17l-.41.24h-.11a.34.34 0 0 1 0-.16v-.16Zm.94-3.18a2.13 2.13 0 0 0-.08-.6.93.93 0 0 0-.24-.39.52.52 0 0 0-.36-.13.9.9 0 0 0-.46.14 1.87 1.87 0 0 0-.46.39 2.61 2.61 0 0 0-.36.55 2.71 2.71 0 0 0-.23.66 2.8 2.8 0 0 0-.09.7 1.82 1.82 0 0 0 .09.61.84.84 0 0 0 .23.38.57.57 0 0 0 .36.14.92.92 0 0 0 .46-.15 1.52 1.52 0 0 0 .46-.39 2.61 2.61 0 0 0 .36-.55 2.92 2.92 0 0 0 .32-1.36Z",
    style: {
      fill: "#455a64",
      transformOrigin: "155.91px 222.81px"
    },
    id: "el0ompr5knhav",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.49 213.32a.57.57 0 0 1-.06.25.35.35 0 0 1-.14.17l-.29.17h-.14a.24.24 0 0 1-.06-.18v-6.19l-1.19 2.06c0 .09-.09.14-.14.15a.1.1 0 0 1-.13 0l-.18-.25a.3.3 0 0 1 0-.2.57.57 0 0 1 .08-.25l1.56-2.74a.49.49 0 0 1 .12-.15l.08-.16.29-.17h.14a.24.24 0 0 1 .06.18Z",
    style: {
      fill: "#455a64",
      transformOrigin: "177.317px 209.87px"
    },
    id: "elcfj0k6sgwr9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.21 206v1.9a9.09 9.09 0 0 1-.12 1.29 6 6 0 0 1-.34 1.18 3.94 3.94 0 0 1-.57 1 3.17 3.17 0 0 1-.83.72 1.42 1.42 0 0 1-.83.24.82.82 0 0 1-.58-.32 1.86 1.86 0 0 1-.33-.79 5.52 5.52 0 0 1-.13-1.15v-1.9a7.83 7.83 0 0 1 .13-1.29 5.54 5.54 0 0 1 .33-1.18 4.44 4.44 0 0 1 .58-1 3 3 0 0 1 .83-.72 1.38 1.38 0 0 1 .83-.23.8.8 0 0 1 .57.32 2.07 2.07 0 0 1 .34.79 6.45 6.45 0 0 1 .12 1.14Zm-3 3.66a2.27 2.27 0 0 0 .31 1.39c.2.22.49.23.87 0a2.1 2.1 0 0 0 .86-1 4.5 4.5 0 0 0 .31-1.75v-1.94a2.29 2.29 0 0 0-.31-1.4c-.2-.23-.48-.23-.86 0a2.07 2.07 0 0 0-.87 1 4.55 4.55 0 0 0-.31 1.76v.95c0 .3-.04.67-.04 1.01Z",
    style: {
      fill: "#455a64",
      transformOrigin: "181.345px 208.04px"
    },
    id: "els7kezyqv6ab",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.15 199.08a.57.57 0 0 1-.06.25.35.35 0 0 1-.14.17l-.3.17a.11.11 0 0 1-.14 0 .22.22 0 0 1-.06-.18v-6.19l-1.18 2.06a.28.28 0 0 1-.14.16.14.14 0 0 1-.14 0l-.17-.25a.25.25 0 0 1 0-.2.57.57 0 0 1 .08-.25l1.56-2.74a.49.49 0 0 1 .12-.15l.11-.08.3-.17h.14a.24.24 0 0 1 .06.18Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "201.995px 195.688px"
    },
    id: "eli3cowvm787",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.22 197.31a.69.69 0 0 1-.05.24.35.35 0 0 1-.14.17l-.3.18a.12.12 0 0 1-.14 0 .24.24 0 0 1-.06-.18v-6.2l-1.18 2.07a.35.35 0 0 1-.15.15.11.11 0 0 1-.13 0l-.18-.24a.41.41 0 0 1 0-.21.75.75 0 0 1 .08-.24l1.56-2.75a.43.43 0 0 1 .12-.14l.12-.08.3-.18a.12.12 0 0 1 .14 0 .3.3 0 0 1 .05.18Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "205.068px 193.9px"
    },
    id: "elp4e9z7f6lko",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.44 185.64a.54.54 0 0 1-.06.25.35.35 0 0 1-.14.17l-.3.17a.09.09 0 0 1-.13 0 .22.22 0 0 1-.06-.18v-6.19l-1.19 2.06a.28.28 0 0 1-.14.16.12.12 0 0 1-.13 0l-.18-.25a.3.3 0 0 1 0-.2.57.57 0 0 1 .08-.25l1.56-2.74a.49.49 0 0 1 .12-.15l.11-.08.3-.17h.14a.24.24 0 0 1 .06.18Z",
    style: {
      fill: "#455a64",
      transformOrigin: "225.287px 182.249px"
    },
    id: "ele07eoblu7c4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.63 180a4.32 4.32 0 0 0 .33-.81 3.33 3.33 0 0 0 .11-.89 1.34 1.34 0 0 0-.23-.86c-.15-.18-.39-.17-.71 0a1.58 1.58 0 0 0-.44.37 2.3 2.3 0 0 0-.3.48 3.35 3.35 0 0 0-.19.56c0 .19-.08.39-.11.59a.52.52 0 0 1-.08.23.25.25 0 0 1-.11.13l-.33.2a.1.1 0 0 1-.12 0 .2.2 0 0 1 0-.14 4.52 4.52 0 0 1 .13-.92 5.84 5.84 0 0 1 .33-1 4.61 4.61 0 0 1 .54-.88 2.48 2.48 0 0 1 .73-.65 1.37 1.37 0 0 1 .71-.22.76.76 0 0 1 .51.23 1.33 1.33 0 0 1 .31.58 3.25 3.25 0 0 1 .1.87v.68a6.18 6.18 0 0 1-.12.62 6.08 6.08 0 0 1-.22.64c-.09.21-.19.45-.32.69l-1.63 3.28 2.24-1.29a.11.11 0 0 1 .14 0 .3.3 0 0 1 .05.18v.4a.7.7 0 0 1-.05.25.41.41 0 0 1-.14.17l-3.15 1.82a.11.11 0 0 1-.14 0 .24.24 0 0 1-.06-.18v-.41a.59.59 0 0 1 0-.23 1.5 1.5 0 0 1 .12-.29Z",
    style: {
      fill: "#455a64",
      transformOrigin: "229.175px 180.763px"
    },
    id: "elh1cww84xme",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.27 171.88a.79.79 0 0 1-.05.25.41.41 0 0 1-.14.17l-.3.17h-.14a.24.24 0 0 1-.06-.18v-6.19l-1.18 2.06q-.08.14-.15.15a.11.11 0 0 1-.13 0l-.18-.25a.4.4 0 0 1 0-.2.73.73 0 0 1 .08-.25l1.56-2.75a.58.58 0 0 1 .12-.14l.12-.08.3-.17a.11.11 0 0 1 .14 0 .26.26 0 0 1 .05.18Z",
    style: {
      fill: "#455a64",
      transformOrigin: "249.119px 168.457px"
    },
    id: "elqk2v9bfiok",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.8 169.4a1.32 1.32 0 0 0 .1.3.41.41 0 0 0 .2.21.64.64 0 0 0 .35 0 1.66 1.66 0 0 0 .55-.23 2 2 0 0 0 .44-.34 2.13 2.13 0 0 0 .35-.47 2.31 2.31 0 0 0 .25-.58 2.5 2.5 0 0 0 .09-.69 1.39 1.39 0 0 0-.09-.56.47.47 0 0 0-.24-.27.58.58 0 0 0-.35 0 2.31 2.31 0 0 0-.45.19l-.6.35a.1.1 0 0 1-.14 0 .21.21 0 0 1-.06-.17v-.41a.52.52 0 0 1 0-.21c0-.07 0-.14.08-.2l1.31-2.93-2.1 1.21a.11.11 0 0 1-.14 0 .24.24 0 0 1-.06-.18V164a.53.53 0 0 1 .06-.24.35.35 0 0 1 .14-.17l2.88-1.66a.11.11 0 0 1 .14 0 .26.26 0 0 1 0 .18v.4a.89.89 0 0 1 0 .22 2.44 2.44 0 0 1-.1.24l-1.29 2.89a1.61 1.61 0 0 1 .67-.21.79.79 0 0 1 .52.16 1.15 1.15 0 0 1 .33.53 2.75 2.75 0 0 1 .12.88 4.56 4.56 0 0 1-.14 1.11 4.86 4.86 0 0 1-.39 1 4.39 4.39 0 0 1-.58.81 3.17 3.17 0 0 1-.71.58 2 2 0 0 1-.84.31.88.88 0 0 1-.58-.12 1 1 0 0 1-.35-.44 2.28 2.28 0 0 1-.12-.66.46.46 0 0 1 0-.2.27.27 0 0 1 .11-.14l.34-.19h.13a.26.26 0 0 1 .17.12Z",
    style: {
      fill: "#455a64",
      transformOrigin: "252.9px 166.472px"
    },
    id: "eld1amp9s0o1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.1 158.12a.57.57 0 0 1-.06.25.41.41 0 0 1-.14.17l-.3.17a.11.11 0 0 1-.14 0 .24.24 0 0 1 0-.18v-6.19l-1.19 2.06c0 .09-.09.14-.14.15a.12.12 0 0 1-.14 0l-.17-.25a.3.3 0 0 1 0-.2.57.57 0 0 1 .08-.25l1.56-2.74a.49.49 0 0 1 .12-.15l.11-.08.3-.17a.11.11 0 0 1 .14 0 .24.24 0 0 1 .06.18Z",
    style: {
      fill: "#455a64",
      transformOrigin: "272.997px 154.71px"
    },
    id: "el216eco7d632",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.54 156.44h-.14a.24.24 0 0 1-.06-.18v-1.56l-2.29 1.3h-.14a.24.24 0 0 1-.06-.18v-.4a.81.81 0 0 1 0-.2 1 1 0 0 1 .15-.22l2.31-6a1.13 1.13 0 0 1 .13-.27.44.44 0 0 1 .16-.17l.29-.16a.11.11 0 0 1 .14 0 .25.25 0 0 1 .06.18v4.69l.62-.36a.12.12 0 0 1 .14 0 .24.24 0 0 1 .06.18v.41a.53.53 0 0 1-.06.24.31.31 0 0 1-.14.17l-.62.37v1.55a.82.82 0 0 1-.06.25.41.41 0 0 1-.14.17Zm-.2-2.75v-3.17l-1.58 4.08Z",
    style: {
      fill: "#455a64",
      transformOrigin: "276.877px 152.407px"
    },
    id: "eldqwl991hsz8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.88 265.79a.53.53 0 0 1-.06.24.35.35 0 0 1-.14.17l-.3.18a.11.11 0 0 1-.14 0 .24.24 0 0 1-.06-.18V260l-1.18 2.06a.27.27 0 0 1-.15.15.11.11 0 0 1-.13 0l-.17-.24a.28.28 0 0 1 0-.21.55.55 0 0 1 .07-.24l1.57-2.75a.42.42 0 0 1 .11-.14l.12-.08.3-.18a.12.12 0 0 1 .14 0 .24.24 0 0 1 .06.18Z",
    style: {
      fill: "#455a64",
      transformOrigin: "129.725px 262.376px"
    },
    id: "elepj9fwwd58w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.42 263.15a.72.72 0 0 0 .41.6.88.88 0 0 0 .75-.12 1.87 1.87 0 0 0 .45-.36 2.22 2.22 0 0 0 .37-.52 2.93 2.93 0 0 0 .25-.65 3.19 3.19 0 0 0 .09-.77 2 2 0 0 0-.09-.66.81.81 0 0 0-.25-.37.57.57 0 0 0-.37-.09 1.11 1.11 0 0 0-.45.16 1.61 1.61 0 0 0-.44.35 3.36 3.36 0 0 0-.27.36l-.19.31a.51.51 0 0 1-.2.21l-.37.21a.08.08 0 0 1-.11 0 .21.21 0 0 1-.05-.15l.22-3.88a.57.57 0 0 1 .06-.25.35.35 0 0 1 .14-.17l2.57-1.49h.14a.24.24 0 0 1 .06.18v.41a.53.53 0 0 1-.06.24.31.31 0 0 1-.14.17l-2.12 1.23-.12 2a4.87 4.87 0 0 1 .34-.37 2.59 2.59 0 0 1 .54-.39 1.66 1.66 0 0 1 .72-.24.88.88 0 0 1 .59.18 1.38 1.38 0 0 1 .4.61 3.26 3.26 0 0 1 .14 1 5.17 5.17 0 0 1-.14 1.19 5 5 0 0 1-.4 1.06 4.28 4.28 0 0 1-.59.87 3 3 0 0 1-.72.59 2 2 0 0 1-.7.25.92.92 0 0 1-.58-.11 1 1 0 0 1-.41-.45 2 2 0 0 1-.16-.78.49.49 0 0 1 .05-.2.33.33 0 0 1 .11-.14l.34-.19a.09.09 0 0 1 .11 0s.06.1.08.17Z",
    style: {
      fill: "#455a64",
      transformOrigin: "133.58px 260.364px"
    },
    id: "elygsxpqx8yrn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.74 252a.53.53 0 0 1-.06.24.35.35 0 0 1-.13.17l-.3.18h-.14a.24.24 0 0 1-.06-.18v-6.2l-1.18 2.07a.35.35 0 0 1-.15.15.11.11 0 0 1-.13 0l-.18-.24a.41.41 0 0 1 0-.21.75.75 0 0 1 .08-.24L154 245a.43.43 0 0 1 .12-.14l.12-.08.3-.18a.1.1 0 0 1 .13 0 .24.24 0 0 1 .06.18Z",
    style: {
      fill: "#455a64",
      transformOrigin: "153.568px 248.583px"
    },
    id: "elmtu7jzy6yq9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.24 245.62a.75.75 0 0 1 .13-.11.5.5 0 0 1 .13-.1 1.5 1.5 0 0 1 .76-.23.93.93 0 0 1 .6.23 1.51 1.51 0 0 1 .39.63 3 3 0 0 1 .14 1 4.58 4.58 0 0 1-.14 1.15 5.64 5.64 0 0 1-.39 1.09 4.86 4.86 0 0 1-.6.92 3 3 0 0 1-.76.64 1.47 1.47 0 0 1-.75.23.93.93 0 0 1-.6-.23 1.52 1.52 0 0 1-.4-.63 3.24 3.24 0 0 1-.14-1 4.23 4.23 0 0 1 0-.63 5.31 5.31 0 0 1 .12-.6c.05-.2.11-.39.17-.57l.19-.54 1.33-3.78a1.82 1.82 0 0 0 .08-.19.35.35 0 0 1 .15-.17l.42-.24a.08.08 0 0 1 .1 0 .25.25 0 0 1 0 .16.28.28 0 0 1 0 .09.64.64 0 0 1 0 .07Zm-.93 3.19a1.76 1.76 0 0 0 .08.59.88.88 0 0 0 .24.41.6.6 0 0 0 .37.16 1.05 1.05 0 0 0 .5-.15 1.85 1.85 0 0 0 .5-.43 2.65 2.65 0 0 0 .38-.6 3.81 3.81 0 0 0 .24-.67 3.4 3.4 0 0 0 .08-.69 2.05 2.05 0 0 0-.08-.59 1.09 1.09 0 0 0-.24-.41.57.57 0 0 0-.38-.16 1.08 1.08 0 0 0-.5.15 2 2 0 0 0-.5.43 2.78 2.78 0 0 0-.37.59 2.9 2.9 0 0 0-.24.68 2.82 2.82 0 0 0-.08.69Z",
    style: {
      fill: "#455a64",
      transformOrigin: "157.495px 246.771px"
    },
    id: "elk6xxd0uyh8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.93 238.05a.53.53 0 0 1-.06.24.35.35 0 0 1-.14.17l-.3.18a.12.12 0 0 1-.14 0 .24.24 0 0 1-.06-.18v-6.2l-1.18 2.07a.27.27 0 0 1-.15.15.13.13 0 0 1-.13 0l-.17-.24a.28.28 0 0 1 0-.21.51.51 0 0 1 .07-.24l1.53-2.79a.45.45 0 0 1 .11-.15l.12-.07.3-.18a.12.12 0 0 1 .14 0 .24.24 0 0 1 .06.18Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "177.755px 234.62px"
    },
    id: "eld3tzkvm2hus",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.83 228.22a.12.12 0 0 1 .14 0 .24.24 0 0 1 .06.18v.41a1.8 1.8 0 0 1 0 .22l-.06.27-1.62 7.38a1.55 1.55 0 0 1-.08.23.31.31 0 0 1-.13.16l-.34.2a.09.09 0 0 1-.12 0s0-.08 0-.16v-.05a.84.84 0 0 1 0-.1l1.63-7.39-2.4 1.38a.11.11 0 0 1-.14 0 .24.24 0 0 1-.06-.18v-.4a.54.54 0 0 1 .06-.25.41.41 0 0 1 .14-.17Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "181.371px 232.745px"
    },
    id: "elzyltsqaw7eo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.46 224.46a.53.53 0 0 1-.06.24.35.35 0 0 1-.14.17l-.3.18a.12.12 0 0 1-.14 0 .24.24 0 0 1-.06-.18v-6.2l-1.18 2.07a.29.29 0 0 1-.14.15.12.12 0 0 1-.14 0l-.17-.25a.29.29 0 0 1 0-.2.53.53 0 0 1 .08-.24l1.56-2.75a.43.43 0 0 1 .12-.14.28.28 0 0 1 .11-.08l.3-.18a.12.12 0 0 1 .14 0 .24.24 0 0 1 .06.18Z",
    style: {
      fill: "#455a64",
      transformOrigin: "201.307px 221.05px"
    },
    id: "eltwn61wd86yj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.39 222a3.76 3.76 0 0 1 .19-1.17 4.5 4.5 0 0 1 .52-1.11 1 1 0 0 1-.42-.49 2.12 2.12 0 0 1-.15-.85 3.42 3.42 0 0 1 .13-.93 4.21 4.21 0 0 1 .89-1.69 2.74 2.74 0 0 1 .68-.56 1.47 1.47 0 0 1 .67-.22.89.89 0 0 1 .54.16 1.06 1.06 0 0 1 .36.5 2.27 2.27 0 0 1 .13.78 3.29 3.29 0 0 1-.16 1 4.26 4.26 0 0 1-.42 1 1 1 0 0 1 .52.51 2.11 2.11 0 0 1 .19 1 3.74 3.74 0 0 1-.14 1 4.25 4.25 0 0 1-.38 1 3.8 3.8 0 0 1-.58.84 2.76 2.76 0 0 1-.73.61 1.49 1.49 0 0 1-.74.24.87.87 0 0 1-.58-.17 1.09 1.09 0 0 1-.38-.52 2.34 2.34 0 0 1-.14-.93Zm.7-.4a1.15 1.15 0 0 0 .08.48.59.59 0 0 0 .23.28.54.54 0 0 0 .36.08 1.09 1.09 0 0 0 .47-.16 2 2 0 0 0 .46-.37 2.54 2.54 0 0 0 .36-.5 2.21 2.21 0 0 0 .23-.55 2 2 0 0 0 .09-.57 1.14 1.14 0 0 0-.09-.48.56.56 0 0 0-.59-.36 1 1 0 0 0-.46.16 2.07 2.07 0 0 0-.47.37 2.8 2.8 0 0 0-.36.49 3 3 0 0 0-.23.56 1.87 1.87 0 0 0-.08.55Zm.14-3.62a1.06 1.06 0 0 0 .07.42.55.55 0 0 0 .21.26.66.66 0 0 0 .32.07.92.92 0 0 0 .4-.14 1.45 1.45 0 0 0 .39-.32 2.3 2.3 0 0 0 .33-.44 2.21 2.21 0 0 0 .21-.5 1.79 1.79 0 0 0 .07-.51 1.06 1.06 0 0 0-.07-.42.55.55 0 0 0-.21-.26.58.58 0 0 0-.33-.06.82.82 0 0 0-.39.13 1.52 1.52 0 0 0-.4.32 2.75 2.75 0 0 0-.32.44 2.21 2.21 0 0 0-.21.5 1.84 1.84 0 0 0-.07.53Z",
    style: {
      fill: "#455a64",
      transformOrigin: "205.225px 219.301px"
    },
    id: "elzbaxnvoib4j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.45 210.61a.57.57 0 0 1-.06.25.35.35 0 0 1-.14.17l-.29.17h-.14a.23.23 0 0 1-.06-.18v-6.19l-1.18 2.06a.33.33 0 0 1-.15.16.12.12 0 0 1-.13 0l-.18-.25a.3.3 0 0 1 0-.2.73.73 0 0 1 .08-.25l1.56-2.74a.49.49 0 0 1 .12-.15l.12-.08.29-.17h.14a.24.24 0 0 1 .06.18Z",
    style: {
      fill: "#455a64",
      transformOrigin: "225.297px 207.205px"
    },
    id: "el8etz2p5xnwb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m229.29 206.58-.11.08-.09.06a1.44 1.44 0 0 1-.68.21.83.83 0 0 1-.59-.17 1.35 1.35 0 0 1-.41-.59 3.05 3.05 0 0 1-.16-1 4.46 4.46 0 0 1 .15-1.14 5.48 5.48 0 0 1 .4-1.07 4.71 4.71 0 0 1 .58-.89 2.82 2.82 0 0 1 .71-.61 1.55 1.55 0 0 1 .76-.24.86.86 0 0 1 .58.23 1.29 1.29 0 0 1 .36.62 3.21 3.21 0 0 1 .13 1 3.38 3.38 0 0 1-.06.6c0 .21-.09.42-.14.64s-.13.42-.19.63-.13.39-.19.55l-1.34 3.72c0 .06 0 .12-.08.19a.35.35 0 0 1-.15.17l-.41.24a.08.08 0 0 1-.11 0 .21.21 0 0 1 0-.15.31.31 0 0 1 0-.1v-.07Zm.94-3.17a1.82 1.82 0 0 0-.09-.61.83.83 0 0 0-.23-.39.57.57 0 0 0-.36-.13 1 1 0 0 0-.46.14 1.91 1.91 0 0 0-.47.39 3.43 3.43 0 0 0-.35.55 3.71 3.71 0 0 0-.24.66 3.42 3.42 0 0 0-.08.7 2.1 2.1 0 0 0 .08.61.89.89 0 0 0 .24.38.52.52 0 0 0 .35.14 1 1 0 0 0 .47-.14 2.07 2.07 0 0 0 .46-.39 2.68 2.68 0 0 0 .36-.56 2.78 2.78 0 0 0 .23-.65 2.74 2.74 0 0 0 .09-.7Z",
    style: {
      fill: "#455a64",
      transformOrigin: "229.086px 205.526px"
    },
    id: "elsza406bbxk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.66 193.37a4 4 0 0 0 .33-.8 3.33 3.33 0 0 0 .11-.89 1.34 1.34 0 0 0-.23-.86c-.15-.18-.39-.17-.71 0a1.58 1.58 0 0 0-.44.37 2 2 0 0 0-.3.48 3.35 3.35 0 0 0-.19.56c0 .19-.08.39-.11.59a.57.57 0 0 1-.08.23.25.25 0 0 1-.11.13l-.34.2a.09.09 0 0 1-.11 0 .21.21 0 0 1 0-.15 4.53 4.53 0 0 1 .13-.91 5 5 0 0 1 .33-1 4.61 4.61 0 0 1 .54-.88 2.36 2.36 0 0 1 .73-.65 1.35 1.35 0 0 1 .71-.22.79.79 0 0 1 .51.22 1.43 1.43 0 0 1 .31.59 3.25 3.25 0 0 1 .1.87v.68c0 .21-.07.41-.12.62a6.08 6.08 0 0 1-.22.64c-.09.21-.19.44-.32.69l-1.63 3.28 2.23-1.29h.14a.24.24 0 0 1 .06.18v.4a.57.57 0 0 1-.06.25.35.35 0 0 1-.14.17l-3.14 1.82h-.14a.24.24 0 0 1-.06-.18v-.41a.59.59 0 0 1 0-.23 1.5 1.5 0 0 1 .12-.29Z",
    style: {
      fill: "#455a64",
      transformOrigin: "249.205px 194.13px"
    },
    id: "eltf4966w81wc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.44 189.3v1.9a9.09 9.09 0 0 1-.12 1.29 6.21 6.21 0 0 1-.34 1.18 4.52 4.52 0 0 1-.58 1 2.7 2.7 0 0 1-.83.71 1.41 1.41 0 0 1-.82.25.83.83 0 0 1-.58-.32 2.07 2.07 0 0 1-.34-.79 6.45 6.45 0 0 1-.12-1.15v-1.95a9.09 9.09 0 0 1 .12-1.29 6 6 0 0 1 .34-1.18 3.9 3.9 0 0 1 .58-1 3 3 0 0 1 .82-.72 1.44 1.44 0 0 1 .83-.24.89.89 0 0 1 .58.33 2 2 0 0 1 .34.79 6.35 6.35 0 0 1 .12 1.19Zm-3 3.65a2.31 2.31 0 0 0 .31 1.4c.2.22.48.22.86 0a2.09 2.09 0 0 0 .87-1 4.55 4.55 0 0 0 .31-1.76v-1.95a2.33 2.33 0 0 0-.31-1.4c-.2-.22-.49-.23-.87 0a2.1 2.1 0 0 0-.86 1 4.59 4.59 0 0 0-.31 1.76v1c0 .34-.05.62-.04 1Z",
    style: {
      fill: "#455a64",
      transformOrigin: "253.575px 191.31px"
    },
    id: "elgptz75dac7i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.32 179.14a6.29 6.29 0 0 0 .33-.81 3.33 3.33 0 0 0 .11-.89 1.34 1.34 0 0 0-.23-.86c-.15-.18-.39-.17-.72 0a1.53 1.53 0 0 0-.43.37 2 2 0 0 0-.3.48 3.35 3.35 0 0 0-.19.56 5.59 5.59 0 0 0-.11.59.69.69 0 0 1-.08.23.3.3 0 0 1-.11.13l-.34.2a.09.09 0 0 1-.11 0 .21.21 0 0 1-.05-.15 4.53 4.53 0 0 1 .13-.91 4.45 4.45 0 0 1 .33-1 4.61 4.61 0 0 1 .54-.88 2.45 2.45 0 0 1 .72-.65 1.4 1.4 0 0 1 .71-.22.72.72 0 0 1 .51.23 1.28 1.28 0 0 1 .31.58 3.23 3.23 0 0 1 .11.87 4.88 4.88 0 0 1 0 .68 3.24 3.24 0 0 1-.12.62 4.34 4.34 0 0 1-.21.64c-.09.21-.2.45-.32.69l-1.67 3.36 2.23-1.29h.14a.24.24 0 0 1 .06.18v.4a.54.54 0 0 1-.06.25.35.35 0 0 1-.14.17l-3.14 1.82h-.14a.24.24 0 0 1-.06-.18v-.41a.85.85 0 0 1 0-.23 3 3 0 0 1 .13-.29Z",
    style: {
      fill: "#455a64",
      transformOrigin: "273.787px 179.93px"
    },
    id: "elrtwjl6eoqi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.45 180.58a.54.54 0 0 1-.06.25.35.35 0 0 1-.14.17l-.3.17a.09.09 0 0 1-.13 0 .22.22 0 0 1-.06-.18v-6.19l-1.19 2.06a.28.28 0 0 1-.14.16.12.12 0 0 1-.13 0l-.18-.25a.29.29 0 0 1 0-.2.62.62 0 0 1 .08-.24l1.56-2.75a.49.49 0 0 1 .12-.15l.11-.08.3-.17h.14a.24.24 0 0 1 .06.18Z",
    style: {
      fill: "#455a64",
      transformOrigin: "277.297px 177.189px"
    },
    id: "eljhrj18jauqh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.45 287.18a4.32 4.32 0 0 0 .33-.81 3.33 3.33 0 0 0 .11-.89 1.34 1.34 0 0 0-.23-.86c-.15-.18-.39-.17-.71 0a1.58 1.58 0 0 0-.44.37 2 2 0 0 0-.3.48 3.35 3.35 0 0 0-.19.56c0 .19-.08.39-.11.59a.78.78 0 0 1-.08.23.25.25 0 0 1-.11.13l-.34.2a.09.09 0 0 1-.11 0 .21.21 0 0 1-.05-.15 4.53 4.53 0 0 1 .13-.91 5 5 0 0 1 .33-1 4.61 4.61 0 0 1 .54-.88 2.36 2.36 0 0 1 .73-.65 1.34 1.34 0 0 1 .7-.22.8.8 0 0 1 .52.22 1.56 1.56 0 0 1 .31.59 3.25 3.25 0 0 1 .1.87v.68c0 .21-.07.41-.12.62a6.08 6.08 0 0 1-.22.64c-.09.21-.2.44-.32.69l-1.66 3.32 2.23-1.29h.14a.24.24 0 0 1 .06.18v.4a.57.57 0 0 1-.06.25.35.35 0 0 1-.14.17l-3.14 1.82h-.14a.24.24 0 0 1-.06-.18v-.41a.59.59 0 0 1 0-.23 1.5 1.5 0 0 1 .12-.29Z",
    style: {
      fill: "#455a64",
      transformOrigin: "129.915px 287.95px"
    },
    id: "elfz28u10vm3p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.7 284.72a3.84 3.84 0 0 0 .33-.81 3.25 3.25 0 0 0 .11-.88 1.35 1.35 0 0 0-.23-.87c-.15-.17-.39-.17-.71 0a1.57 1.57 0 0 0-.44.36 2.41 2.41 0 0 0-.3.48 3.69 3.69 0 0 0-.19.56c0 .2-.08.4-.11.59a.85.85 0 0 1-.08.24.29.29 0 0 1-.11.13l-.34.19a.08.08 0 0 1-.11 0 .21.21 0 0 1-.05-.15 4.72 4.72 0 0 1 .13-.92 5 5 0 0 1 .33-1 4.69 4.69 0 0 1 .54-.89 2.33 2.33 0 0 1 .73-.64 1.26 1.26 0 0 1 .7-.22.75.75 0 0 1 .52.22 1.56 1.56 0 0 1 .31.59 3.25 3.25 0 0 1 .1.87v.67a4.7 4.7 0 0 1-.13.63 3.88 3.88 0 0 1-.21.63c-.09.22-.2.45-.32.7l-1.63 3.27 2.23-1.29a.12.12 0 0 1 .14 0 .24.24 0 0 1 .06.18v.41a.61.61 0 0 1-.06.25.35.35 0 0 1-.14.17l-3.14 1.81h-.14a.22.22 0 0 1-.06-.18v-.4a.67.67 0 0 1 0-.24 1.77 1.77 0 0 1 .12-.28Z",
    style: {
      fill: "#455a64",
      transformOrigin: "134.195px 285.445px"
    },
    id: "ell9tkwons11",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.28 273.41a4 4 0 0 0 .33-.8 3.38 3.38 0 0 0 .11-.89 1.26 1.26 0 0 0-.23-.86c-.15-.18-.39-.18-.71 0a1.73 1.73 0 0 0-.44.36 2.18 2.18 0 0 0-.29.49 2.48 2.48 0 0 0-.2.56c0 .19-.08.39-.11.58a.57.57 0 0 1-.08.24.25.25 0 0 1-.11.13l-.33.2a.1.1 0 0 1-.12 0 .21.21 0 0 1 0-.15 3.86 3.86 0 0 1 .12-.91 4.86 4.86 0 0 1 .34-1 4.45 4.45 0 0 1 .53-.89 2.59 2.59 0 0 1 .73-.64 1.29 1.29 0 0 1 .71-.22.79.79 0 0 1 .51.22 1.43 1.43 0 0 1 .31.59 3.25 3.25 0 0 1 .1.87v.67c0 .2-.07.42-.12.63a6.08 6.08 0 0 1-.22.64c-.09.21-.19.44-.32.69l-1.63 3.28 2.24-1.29a.11.11 0 0 1 .14 0 .26.26 0 0 1 .05.18v.4a.74.74 0 0 1-.05.25.41.41 0 0 1-.14.17l-3.15 1.82a.12.12 0 0 1-.14 0 .24.24 0 0 1-.06-.18v-.41a.59.59 0 0 1 0-.23 1.5 1.5 0 0 1 .12-.29Z",
    style: {
      fill: "#455a64",
      transformOrigin: "153.815px 274.181px"
    },
    id: "elrj1cnn1tw6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.87 274.16a1.76 1.76 0 0 0 .1.3.45.45 0 0 0 .2.21.61.61 0 0 0 .34 0 1.75 1.75 0 0 0 .56-.24 1.65 1.65 0 0 0 .43-.33 1.89 1.89 0 0 0 .36-.47 2.83 2.83 0 0 0 .25-.59 2.48 2.48 0 0 0 .09-.68 1.48 1.48 0 0 0-.09-.57.48.48 0 0 0-.24-.26.52.52 0 0 0-.35 0 2.08 2.08 0 0 0-.45.19l-.6.35h-.14a.24.24 0 0 1-.06-.18v-.4a.52.52 0 0 1 0-.21c0-.07.05-.14.08-.2l1.31-2.94-2.1 1.22a.12.12 0 0 1-.14 0 .24.24 0 0 1-.06-.18v-.41a.61.61 0 0 1 .06-.25.4.4 0 0 1 .14-.17l2.87-1.66a.12.12 0 0 1 .14 0 .24.24 0 0 1 .06.18v.41a.82.82 0 0 1 0 .21c0 .08-.06.16-.1.25l-1.29 2.89a1.57 1.57 0 0 1 .67-.21.7.7 0 0 1 .51.16 1.09 1.09 0 0 1 .34.53 2.71 2.71 0 0 1 .12.88 4.56 4.56 0 0 1-.14 1.11 4.36 4.36 0 0 1-.4 1 3.93 3.93 0 0 1-.57.81 3.17 3.17 0 0 1-.71.58 2.18 2.18 0 0 1-.84.31.87.87 0 0 1-.59-.13 1 1 0 0 1-.34-.44 2.15 2.15 0 0 1-.12-.65.54.54 0 0 1 0-.21.29.29 0 0 1 .11-.13l.34-.2a.1.1 0 0 1 .13 0 .23.23 0 0 1 .12.12Z",
    style: {
      fill: "#455a64",
      transformOrigin: "158.02px 271.238px"
    },
    id: "elerttfps4l75",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.11 259.66a6.29 6.29 0 0 0 .33-.81 3.25 3.25 0 0 0 .11-.88 1.35 1.35 0 0 0-.23-.87c-.15-.18-.39-.17-.72 0a1.68 1.68 0 0 0-.43.36 2.15 2.15 0 0 0-.3.48 3.69 3.69 0 0 0-.19.56c-.05.2-.08.39-.11.59a.85.85 0 0 1-.08.24.37.37 0 0 1-.11.13l-.34.19a.07.07 0 0 1-.11 0 .18.18 0 0 1-.05-.14 5.41 5.41 0 0 1 .12-.92 5.09 5.09 0 0 1 .34-1 4.42 4.42 0 0 1 .54-.88 2.41 2.41 0 0 1 .72-.64 1.31 1.31 0 0 1 .71-.22.71.71 0 0 1 .51.22 1.27 1.27 0 0 1 .31.59 3.23 3.23 0 0 1 .11.87 4.73 4.73 0 0 1 0 .67 3.5 3.5 0 0 1-.12.63 5.17 5.17 0 0 1-.21.63c-.09.22-.2.45-.32.69l-1.63 3.28 2.23-1.29h.14a.24.24 0 0 1 .06.18v.41a.53.53 0 0 1-.06.24.31.31 0 0 1-.14.17L176 265a.09.09 0 0 1-.13 0 .24.24 0 0 1-.06-.18v-.4a1 1 0 0 1 0-.24 3 3 0 0 1 .13-.28Z",
    style: {
      fill: "#455a64",
      transformOrigin: "177.597px 260.439px"
    },
    id: "el61uv47lx9t9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.61 261.2h-.14a.24.24 0 0 1-.06-.18v-1.55l-2.29 1.32h-.14a.22.22 0 0 1-.06-.18v-.4a1.91 1.91 0 0 1 0-.2 2.25 2.25 0 0 1 .08-.24l2.31-6a1.69 1.69 0 0 1 .13-.27.34.34 0 0 1 .15-.16l.29-.17h.14a.22.22 0 0 1 .06.18v4.7l.63-.37a.12.12 0 0 1 .14 0 .24.24 0 0 1 .06.18v.41a.61.61 0 0 1-.06.25.41.41 0 0 1-.14.17l-.63.36v1.55a.57.57 0 0 1-.06.25.35.35 0 0 1-.14.17Zm-.2-2.75v-3.17l-1.59 4.08Z",
    style: {
      fill: "#455a64",
      transformOrigin: "181.914px 257.185px"
    },
    id: "el2ngrqcp2w9v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.05 245.84a5 5 0 0 0 .32-.81 3 3 0 0 0 .11-.89 1.34 1.34 0 0 0-.22-.86c-.15-.18-.39-.17-.72 0a1.53 1.53 0 0 0-.43.37 2 2 0 0 0-.3.48 2.64 2.64 0 0 0-.19.56 3.84 3.84 0 0 0-.11.59.69.69 0 0 1-.08.23.38.38 0 0 1-.11.13l-.34.2a.09.09 0 0 1-.11 0 .17.17 0 0 1-.05-.15 4.47 4.47 0 0 1 .12-.91 5.09 5.09 0 0 1 .34-1 4.16 4.16 0 0 1 .54-.88 2.45 2.45 0 0 1 .72-.65 1.4 1.4 0 0 1 .71-.22.77.77 0 0 1 .51.22 1.32 1.32 0 0 1 .31.59 3.23 3.23 0 0 1 .11.87 4.88 4.88 0 0 1 0 .68 3.39 3.39 0 0 1-.12.62c-.06.21-.13.42-.21.64s-.2.44-.33.69l-1.62 3.28 2.23-1.29a.11.11 0 0 1 .14 0 .24.24 0 0 1 .06.18v.4a.57.57 0 0 1-.06.25.41.41 0 0 1-.14.17l-3.15 1.82a.11.11 0 0 1-.14 0 .3.3 0 0 1-.05-.18v-.41a.85.85 0 0 1 0-.23 3 3 0 0 1 .13-.29Z",
    style: {
      fill: "#455a64",
      transformOrigin: "201.557px 246.603px"
    },
    id: "elh123rx5uwld",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.65 246.43a.72.72 0 0 0 .41.59.82.82 0 0 0 .75-.12 1.87 1.87 0 0 0 .45-.36 2.55 2.55 0 0 0 .37-.52 2.93 2.93 0 0 0 .25-.65 3.19 3.19 0 0 0 .09-.77 2 2 0 0 0-.09-.66.81.81 0 0 0-.25-.37.59.59 0 0 0-.37-.09 1.29 1.29 0 0 0-.45.16 1.9 1.9 0 0 0-.45.35c-.1.13-.19.25-.26.36s-.14.22-.2.31a.49.49 0 0 1-.19.21l-.37.22a.09.09 0 0 1-.11 0 .17.17 0 0 1 0-.15l.22-3.88a.57.57 0 0 1 .06-.25.3.3 0 0 1 .14-.17l2.57-1.49a.12.12 0 0 1 .14 0 .24.24 0 0 1 .06.18v.41a.53.53 0 0 1-.06.24.38.38 0 0 1-.14.18l-2.12 1.22-.12 2a4.87 4.87 0 0 1 .34-.37 2.69 2.69 0 0 1 .54-.39 1.66 1.66 0 0 1 .72-.24.84.84 0 0 1 .59.19 1.29 1.29 0 0 1 .4.6 3.26 3.26 0 0 1 .14 1 5.17 5.17 0 0 1-.14 1.19 5 5 0 0 1-.4 1.07 4.5 4.5 0 0 1-.59.86 3 3 0 0 1-.72.59 1.65 1.65 0 0 1-.7.25 1 1 0 0 1-.59-.11 1 1 0 0 1-.4-.45 1.8 1.8 0 0 1-.16-.78.49.49 0 0 1 0-.2.33.33 0 0 1 .11-.14l.34-.19a.11.11 0 0 1 .11 0 .24.24 0 0 1 .08.17Z",
    style: {
      fill: "#455a64",
      transformOrigin: "205.855px 243.632px"
    },
    id: "ely2daxtl8h48",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.91 232.07a4.32 4.32 0 0 0 .33-.81 3.33 3.33 0 0 0 .11-.89 1.34 1.34 0 0 0-.23-.86c-.15-.18-.39-.17-.71 0a1.58 1.58 0 0 0-.44.37 2 2 0 0 0-.3.48 3.35 3.35 0 0 0-.19.56c0 .19-.08.39-.11.59a.52.52 0 0 1-.08.23.25.25 0 0 1-.11.13l-.33.2a.1.1 0 0 1-.12 0 .21.21 0 0 1 0-.15 4.53 4.53 0 0 1 .13-.91 5.84 5.84 0 0 1 .33-1 4.61 4.61 0 0 1 .54-.88 2.36 2.36 0 0 1 .73-.65 1.37 1.37 0 0 1 .71-.22.79.79 0 0 1 .51.22 1.43 1.43 0 0 1 .31.59 3.25 3.25 0 0 1 .1.87v.68c0 .21-.07.41-.12.62a6.08 6.08 0 0 1-.22.64c-.09.21-.19.44-.32.69l-1.63 3.28 2.24-1.29a.11.11 0 0 1 .14 0 .3.3 0 0 1 .05.18v.4a.74.74 0 0 1-.05.25.41.41 0 0 1-.14.17l-3.15 1.82h-.14a.24.24 0 0 1-.06-.18v-.41a.59.59 0 0 1 0-.23 1.5 1.5 0 0 1 .12-.29Z",
    style: {
      fill: "#455a64",
      transformOrigin: "225.455px 232.82px"
    },
    id: "ell3zpq3d73w8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.47 228.9a.75.75 0 0 1 .13-.11.5.5 0 0 1 .13-.1 1.47 1.47 0 0 1 .76-.23.89.89 0 0 1 .59.23 1.52 1.52 0 0 1 .4.63 3.24 3.24 0 0 1 .14 1 5.09 5.09 0 0 1-.14 1.15 5.67 5.67 0 0 1-.4 1.09 4.38 4.38 0 0 1-.59.92 3.2 3.2 0 0 1-.76.64 1.47 1.47 0 0 1-.75.23.89.89 0 0 1-.6-.23 1.46 1.46 0 0 1-.4-.63 3.19 3.19 0 0 1-.14-1 4.34 4.34 0 0 1 0-.63 5.31 5.31 0 0 1 .12-.6c.05-.2.11-.39.17-.57l.19-.54 1.33-3.78a1.21 1.21 0 0 0 .08-.19.35.35 0 0 1 .15-.17l.41-.24h.11a.25.25 0 0 1 0 .16.25.25 0 0 1 0 .09v.07Zm-.94 3.19a1.85 1.85 0 0 0 .09.6 1 1 0 0 0 .23.4.59.59 0 0 0 .38.16.87.87 0 0 0 .5-.15 1.85 1.85 0 0 0 .5-.43 3.3 3.3 0 0 0 .38-.59 3.41 3.41 0 0 0 .23-.68 2.84 2.84 0 0 0 .09-.69 1.74 1.74 0 0 0-.09-.59 1 1 0 0 0-.23-.41.65.65 0 0 0-.38-.16 1.08 1.08 0 0 0-.5.15 2 2 0 0 0-.5.43 3.06 3.06 0 0 0-.38.6 3.12 3.12 0 0 0-.23.67 2.84 2.84 0 0 0-.09.69Z",
    style: {
      fill: "#455a64",
      transformOrigin: "229.725px 230.06px"
    },
    id: "elzijr0d32xaq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.1 218.1a5 5 0 0 0 .32-.81 2.9 2.9 0 0 0 .11-.88 1.36 1.36 0 0 0-.22-.87c-.15-.18-.39-.17-.72 0a1.68 1.68 0 0 0-.43.36 2.15 2.15 0 0 0-.3.48 2.84 2.84 0 0 0-.19.56c0 .2-.09.39-.12.59a.84.84 0 0 1-.07.24.38.38 0 0 1-.12.13l-.33.19h-.11a.16.16 0 0 1 0-.14 3.94 3.94 0 0 1 .08-.95 5.09 5.09 0 0 1 .34-1 4.38 4.38 0 0 1 .53-.88 2.78 2.78 0 0 1 .73-.65 1.38 1.38 0 0 1 .71-.21.75.75 0 0 1 .51.22 1.28 1.28 0 0 1 .31.58 3.36 3.36 0 0 1 .11.88v.67a3.5 3.5 0 0 1-.12.63 7.27 7.27 0 0 1-.54 1.32l-1.62 3.28 2.23-1.29a.11.11 0 0 1 .14 0 .24.24 0 0 1 .06.18v.41a.53.53 0 0 1-.06.24.35.35 0 0 1-.14.17l-3.19 1.9a.11.11 0 0 1-.14 0 .24.24 0 0 1-.06-.18v-.4a.93.93 0 0 1 0-.24l.12-.28Z",
    style: {
      fill: "#455a64",
      transformOrigin: "249.592px 218.868px"
    },
    id: "elqc2z7bjx3tl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.06 211.5a.11.11 0 0 1 .14 0 .24.24 0 0 1 .06.18v.4a2 2 0 0 1 0 .23q0 .12-.06.27l-1.64 7.42a2.09 2.09 0 0 1-.08.23.32.32 0 0 1-.14.16l-.33.19a.1.1 0 0 1-.13 0 .23.23 0 0 1 0-.16.13.13 0 0 1 0-.06v-.09l1.63-7.39-2.39 1.38h-.14a.24.24 0 0 1-.06-.18v-.41a.53.53 0 0 1 .06-.24.31.31 0 0 1 .14-.17Z",
    style: {
      fill: "#455a64",
      transformOrigin: "253.591px 216.039px"
    },
    id: "elxh8c959egs9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.63 204.51a6.29 6.29 0 0 0 .33-.81 3.25 3.25 0 0 0 .11-.88 1.35 1.35 0 0 0-.23-.87c-.15-.18-.39-.17-.72 0a1.68 1.68 0 0 0-.43.36 2.15 2.15 0 0 0-.3.48 3.69 3.69 0 0 0-.19.56c-.05.2-.08.39-.11.59a.85.85 0 0 1-.08.24.37.37 0 0 1-.11.13l-.34.19a.08.08 0 0 1-.11 0 .25.25 0 0 1-.05-.15 4.62 4.62 0 0 1 .13-.92 5 5 0 0 1 .33-1 4.94 4.94 0 0 1 .54-.88 2.41 2.41 0 0 1 .72-.64 1.31 1.31 0 0 1 .71-.22.71.71 0 0 1 .51.22 1.28 1.28 0 0 1 .31.58 3.36 3.36 0 0 1 .11.88 4.73 4.73 0 0 1 0 .67 3.5 3.5 0 0 1-.12.63 3.88 3.88 0 0 1-.21.63c-.09.22-.2.45-.32.69l-1.63 3.28 2.23-1.29a.12.12 0 0 1 .14 0 .24.24 0 0 1 .06.18v.41a.61.61 0 0 1-.06.25.32.32 0 0 1-.14.16l-3.14 1.82h-.14a.23.23 0 0 1-.06-.18v-.4a.93.93 0 0 1 0-.24 3 3 0 0 1 .13-.28Z",
    style: {
      fill: "#455a64",
      transformOrigin: "273.137px 205.245px"
    },
    id: "el512wdsmjjdn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.62 205.26a3.76 3.76 0 0 1 .19-1.17 4.57 4.57 0 0 1 .52-1.12 1 1 0 0 1-.42-.48 2.12 2.12 0 0 1-.15-.85 3.42 3.42 0 0 1 .13-.93 4 4 0 0 1 .89-1.69 2.66 2.66 0 0 1 .67-.56 1.42 1.42 0 0 1 .68-.22.89.89 0 0 1 .54.16 1.14 1.14 0 0 1 .36.5 2.27 2.27 0 0 1 .13.78 3.67 3.67 0 0 1-.16 1 5 5 0 0 1-.42 1 1.09 1.09 0 0 1 .52.52 2.2 2.2 0 0 1 .19.95 3.81 3.81 0 0 1-.14 1 4.25 4.25 0 0 1-.38 1 3.8 3.8 0 0 1-.58.84 2.83 2.83 0 0 1-.74.61 1.43 1.43 0 0 1-.73.24.87.87 0 0 1-.58-.17 1.07 1.07 0 0 1-.38-.53 2.29 2.29 0 0 1-.14-.88Zm.7-.4a1.1 1.1 0 0 0 .08.47.57.57 0 0 0 .23.29.6.6 0 0 0 .36.08 1.06 1.06 0 0 0 .46-.16 2 2 0 0 0 .46-.37 2.48 2.48 0 0 0 .37-.5 2.75 2.75 0 0 0 .23-.56 1.87 1.87 0 0 0 .08-.57 1.13 1.13 0 0 0-.08-.47.68.68 0 0 0-.23-.29.62.62 0 0 0-.37-.08 1.41 1.41 0 0 0-.46.16 2.07 2.07 0 0 0-.46.38 2.47 2.47 0 0 0-.36.49 2.28 2.28 0 0 0-.23.56 1.87 1.87 0 0 0-.08.57Zm.13-3.62a1.08 1.08 0 0 0 .08.42.48.48 0 0 0 .21.25.49.49 0 0 0 .32.07.82.82 0 0 0 .39-.13 1.52 1.52 0 0 0 .4-.32 2.59 2.59 0 0 0 .32-.44 3.16 3.16 0 0 0 .22-.5 1.89 1.89 0 0 0 .07-.51 1 1 0 0 0-.07-.42.58.58 0 0 0-.22-.26.63.63 0 0 0-.32-.07 1.07 1.07 0 0 0-.4.14 1.66 1.66 0 0 0-.39.32 2.36 2.36 0 0 0-.32.44 2.21 2.21 0 0 0-.21.5 1.81 1.81 0 0 0-.08.51Z",
    style: {
      fill: "#455a64",
      transformOrigin: "277.454px 202.541px"
    },
    id: "elacwvefyt1ac",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.46 312.11a4 4 0 0 0 .33-.8 3.38 3.38 0 0 0 .11-.89 1.34 1.34 0 0 0-.23-.86c-.15-.18-.39-.18-.71 0a1.58 1.58 0 0 0-.44.37 2 2 0 0 0-.3.48 3.07 3.07 0 0 0-.19.56c0 .19-.08.39-.11.58a.75.75 0 0 1-.08.24.25.25 0 0 1-.11.13l-.34.2a.09.09 0 0 1-.11 0 .21.21 0 0 1-.05-.15 4.53 4.53 0 0 1 .13-.91 4.83 4.83 0 0 1 .33-1 5 5 0 0 1 .54-.89 2.46 2.46 0 0 1 .73-.64 1.34 1.34 0 0 1 .7-.22.8.8 0 0 1 .52.22 1.56 1.56 0 0 1 .31.59 3.25 3.25 0 0 1 .1.87v.67c0 .2-.07.42-.12.63a6.08 6.08 0 0 1-.22.64c-.09.21-.2.44-.32.69l-1.63 3.28 2.23-1.29h.14a.23.23 0 0 1 .06.18v.4a.57.57 0 0 1-.06.25.35.35 0 0 1-.14.17l-3.14 1.82a.12.12 0 0 1-.14 0 .24.24 0 0 1-.06-.18v-.41a.59.59 0 0 1 0-.23 1.5 1.5 0 0 1 .12-.29Z",
    style: {
      fill: "#455a64",
      transformOrigin: "129.955px 312.881px"
    },
    id: "elpvkth8lgw0n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m134.35 311.31-.1.07-.1.06a1.43 1.43 0 0 1-.67.22.93.93 0 0 1-.59-.17 1.3 1.3 0 0 1-.41-.6 2.77 2.77 0 0 1-.16-1 4.41 4.41 0 0 1 .15-1.14 5.25 5.25 0 0 1 .4-1.07 4.27 4.27 0 0 1 .58-.89 2.6 2.6 0 0 1 .7-.61 1.42 1.42 0 0 1 .77-.24.83.83 0 0 1 .57.22 1.43 1.43 0 0 1 .37.63 3.14 3.14 0 0 1 .13 1 3.21 3.21 0 0 1-.06.6c0 .22-.09.43-.15.64s-.12.43-.19.63-.13.39-.19.56l-1.33 3.78-.08.19a.33.33 0 0 1-.14.17l-.42.24h-.1a.21.21 0 0 1 0-.15.25.25 0 0 1 0-.09.14.14 0 0 1 0-.07Zm.94-3.18a1.82 1.82 0 0 0-.08-.6.92.92 0 0 0-.23-.39.52.52 0 0 0-.37-.13.9.9 0 0 0-.46.14 1.87 1.87 0 0 0-.46.39 2.61 2.61 0 0 0-.36.55 3.2 3.2 0 0 0-.23.66 2.74 2.74 0 0 0-.08.7 1.84 1.84 0 0 0 .08.61.94.94 0 0 0 .23.38.52.52 0 0 0 .36.13.81.81 0 0 0 .46-.14 1.52 1.52 0 0 0 .46-.39 2.31 2.31 0 0 0 .37-.55 3.33 3.33 0 0 0 .23-.65 2.81 2.81 0 0 0 .08-.71Z",
    style: {
      fill: "#455a64",
      transformOrigin: "134.155px 310.27px"
    },
    id: "ely1xm6npomtb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.43 301.67a1.76 1.76 0 0 0 .1.3.45.45 0 0 0 .2.21.6.6 0 0 0 .34 0 2 2 0 0 0 .56-.24 2.17 2.17 0 0 0 .79-.8 3.49 3.49 0 0 0 .25-.59 2.5 2.5 0 0 0 .09-.69 1.42 1.42 0 0 0-.09-.56.48.48 0 0 0-.24-.26.52.52 0 0 0-.35 0 1.68 1.68 0 0 0-.45.19l-.6.35h-.14a.24.24 0 0 1-.06-.18v-.4a.52.52 0 0 1 0-.21 2.07 2.07 0 0 1 .08-.2l1.31-2.94-2.1 1.22a.11.11 0 0 1-.14 0 .21.21 0 0 1-.06-.17v-.41a.61.61 0 0 1 .08-.29.35.35 0 0 1 .14-.17l2.87-1.66h.14a.24.24 0 0 1 .06.18v.41a.82.82 0 0 1 0 .21l-.1.25-1.29 2.89a1.44 1.44 0 0 1 .67-.21.7.7 0 0 1 .51.16 1 1 0 0 1 .34.53 2.68 2.68 0 0 1 .12.87 4.58 4.58 0 0 1-.14 1.12 4.36 4.36 0 0 1-.4 1 3.93 3.93 0 0 1-.57.81 2.87 2.87 0 0 1-.71.57 2.12 2.12 0 0 1-.84.32.87.87 0 0 1-.59-.13 1 1 0 0 1-.34-.44 2.15 2.15 0 0 1-.12-.65.54.54 0 0 1 0-.21.4.4 0 0 1 .11-.14l.34-.19a.1.1 0 0 1 .13 0 .23.23 0 0 1 .1.15Z",
    style: {
      fill: "#455a64",
      transformOrigin: "153.6px 298.729px"
    },
    id: "elobkpflr4q9i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160 294.34v1.94a7 7 0 0 1-.12 1.29 5.56 5.56 0 0 1-.34 1.18 4.12 4.12 0 0 1-.57 1 2.83 2.83 0 0 1-.83.71 1.44 1.44 0 0 1-.83.25.81.81 0 0 1-.57-.33 2 2 0 0 1-.34-.78 5 5 0 0 1-.12-1.15v-1.9a6.88 6.88 0 0 1 .12-1.29 6 6 0 0 1 .34-1.18 4 4 0 0 1 .57-1 2.72 2.72 0 0 1 .83-.72 1.35 1.35 0 0 1 .83-.24.84.84 0 0 1 .57.33 1.87 1.87 0 0 1 .34.79 5 5 0 0 1 .12 1.1Zm-3 3.65a2.31 2.31 0 0 0 .31 1.4c.19.22.48.22.86 0a2.09 2.09 0 0 0 .87-1 4.75 4.75 0 0 0 .31-1.76v-1.9a2.41 2.41 0 0 0-.31-1.4c-.2-.22-.49-.23-.87 0a2.05 2.05 0 0 0-.86 1 4.59 4.59 0 0 0-.31 1.76v1c0 .34-.08.57-.07.91Z",
    style: {
      fill: "#455a64",
      transformOrigin: "158.14px 296.414px"
    },
    id: "elxg4k1nfk5p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.15 287.39a2.81 2.81 0 0 0 .1.31.43.43 0 0 0 .2.2.49.49 0 0 0 .35 0 1.78 1.78 0 0 0 .56-.23 2.6 2.6 0 0 0 .43-.33 2.73 2.73 0 0 0 .35-.47 2.38 2.38 0 0 0 .25-.59 2.5 2.5 0 0 0 .09-.69 1.42 1.42 0 0 0-.09-.56.5.5 0 0 0-.24-.27.51.51 0 0 0-.35 0 1.63 1.63 0 0 0-.44.19l-.61.35a.11.11 0 0 1-.14 0 .24.24 0 0 1-.06-.18v-.41a1 1 0 0 1 0-.21c0-.07 0-.13.08-.19l1.31-2.94-2.1 1.21a.11.11 0 0 1-.14 0 .23.23 0 0 1-.06-.18v-.4a.57.57 0 0 1 .06-.25.41.41 0 0 1 .14-.17l2.88-1.66a.11.11 0 0 1 .14 0 .24.24 0 0 1 .06.18v.4a.93.93 0 0 1 0 .22 2.44 2.44 0 0 1-.1.24l-1.29 2.89a1.61 1.61 0 0 1 .67-.21.79.79 0 0 1 .52.17 1.11 1.11 0 0 1 .33.52 2.79 2.79 0 0 1 .12.88 4.12 4.12 0 0 1-.14 1.11 4.73 4.73 0 0 1-.39 1 4.39 4.39 0 0 1-.58.81 3 3 0 0 1-.7.57 2.11 2.11 0 0 1-.85.31.9.9 0 0 1-.58-.12.91.91 0 0 1-.35-.44 2.16 2.16 0 0 1-.12-.66.49.49 0 0 1 0-.2.28.28 0 0 1 .12-.14l.33-.19a.1.1 0 0 1 .13 0 .23.23 0 0 1 .11.13Z",
    style: {
      fill: "#455a64",
      transformOrigin: "178.31px 284.456px"
    },
    id: "elw66299fzhw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.91 285.67a.69.69 0 0 1 0 .24.35.35 0 0 1-.14.17l-.3.18a.12.12 0 0 1-.14 0 .24.24 0 0 1-.06-.18v-6.2l-1.27 2.06a.35.35 0 0 1-.15.15.12.12 0 0 1-.13 0l-.18-.25a.35.35 0 0 1 0-.2.68.68 0 0 1 .08-.24l1.56-2.75a.49.49 0 0 1 .12-.15l.12-.07.3-.18a.11.11 0 0 1 .14 0 .3.3 0 0 1 0 .18Z",
    style: {
      fill: "#455a64",
      transformOrigin: "181.723px 282.254px"
    },
    id: "el4gv6cyxbu4d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.69 273.09a.57.57 0 0 1-.06.25.41.41 0 0 1-.14.17l-.3.17a.11.11 0 0 1-.14 0 .24.24 0 0 1-.06-.18v-6.2l-1.18 2.06q-.06.13-.15.15a.11.11 0 0 1-.13 0l-.17-.25a.26.26 0 0 1 0-.2.55.55 0 0 1 .07-.25L204 266a.37.37 0 0 1 .11-.15l.12-.08.3-.17a.11.11 0 0 1 .14 0 .23.23 0 0 1 .06.18Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "203.536px 269.64px"
    },
    id: "els9yftcknmha",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.1 255.75a5 5 0 0 0 .32-.81 2.9 2.9 0 0 0 .11-.88 1.36 1.36 0 0 0-.22-.87c-.15-.18-.39-.17-.72 0a1.68 1.68 0 0 0-.43.36 2.15 2.15 0 0 0-.3.48 2.84 2.84 0 0 0-.19.56c0 .2-.09.39-.12.59a.84.84 0 0 1-.07.24.38.38 0 0 1-.12.13l-.33.19a.08.08 0 0 1-.11 0 .2.2 0 0 1 0-.15 3.94 3.94 0 0 1 .12-.92 5.09 5.09 0 0 1 .34-1 4.38 4.38 0 0 1 .53-.88 2.57 2.57 0 0 1 .73-.64 1.31 1.31 0 0 1 .71-.22.75.75 0 0 1 .51.22 1.28 1.28 0 0 1 .31.58 3.36 3.36 0 0 1 .11.88 4.73 4.73 0 0 1 0 .67 3.5 3.5 0 0 1-.12.63 7.27 7.27 0 0 1-.54 1.32l-1.63 3.28 2.24-1.29a.11.11 0 0 1 .14 0 .24.24 0 0 1 .06.18v.41a.53.53 0 0 1-.06.24.35.35 0 0 1-.14.17L226 261.1a.11.11 0 0 1-.14 0 .24.24 0 0 1-.06-.18v-.4a.93.93 0 0 1 0-.24 3 3 0 0 1 .2-.28Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "227.612px 256.528px"
    },
    id: "eljbcfa3cswns",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.26 245.19a1.82 1.82 0 0 0 .11.3.37.37 0 0 0 .19.2.5.5 0 0 0 .35 0 1.78 1.78 0 0 0 .56-.23 2.6 2.6 0 0 0 .43-.33 3.43 3.43 0 0 0 .36-.47 2.81 2.81 0 0 0 .24-.59 2.5 2.5 0 0 0 .09-.69 1.42 1.42 0 0 0-.09-.56.48.48 0 0 0-.23-.27.55.55 0 0 0-.36 0 1.77 1.77 0 0 0-.44.19l-.61.35a.11.11 0 0 1-.14 0 .24.24 0 0 1-.06-.18v-.41a1 1 0 0 1 0-.21c0-.07.06-.13.08-.19l1.32-2.94-2.06 1.22a.11.11 0 0 1-.14 0s0-.09 0-.18v-.4a.56.56 0 0 1 0-.25.41.41 0 0 1 .14-.17l2.88-1.66a.11.11 0 0 1 .14 0 .24.24 0 0 1 .06.18v.4a.93.93 0 0 1 0 .22 2.34 2.34 0 0 1-.09.24l-1.3 2.9a1.4 1.4 0 0 1 .67-.21.72.72 0 0 1 .52.16 1.12 1.12 0 0 1 .34.52 2.79 2.79 0 0 1 .12.88 4.15 4.15 0 0 1-.15 1.12 4.86 4.86 0 0 1-.39 1 4 4 0 0 1-.58.81 2.83 2.83 0 0 1-.7.57 2.32 2.32 0 0 1-.85.32 1 1 0 0 1-.58-.13.89.89 0 0 1-.34-.44 1.69 1.69 0 0 1-.12-.66.51.51 0 0 1 0-.2.34.34 0 0 1 .12-.14l.33-.19h.13a.23.23 0 0 1 .05.12Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "251.48px 242.264px"
    },
    id: "el9j0q06dyzca",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276 232.22a.11.11 0 0 1-.14 0 .23.23 0 0 1-.06-.18v-1.55l-2.29 1.33a.12.12 0 0 1-.14 0 .25.25 0 0 1-.06-.19v-.4a.88.88 0 0 1 0-.2 1.13 1.13 0 0 1 .08-.24l2.3-6c0-.1.09-.19.13-.27a.49.49 0 0 1 .16-.16l.29-.17a.11.11 0 0 1 .14 0 .24.24 0 0 1 .06.18v4.7l.63-.36a.09.09 0 0 1 .13 0 .22.22 0 0 1 .06.18v.4a.57.57 0 0 1-.06.25.34.34 0 0 1-.13.17l-.63.36v1.55a.57.57 0 0 1-.06.25.41.41 0 0 1-.14.17Zm-.2-2.75v-3.17l-1.58 4.08Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "275.298px 228.205px"
    },
    id: "elrq3acmj4m2j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m126.93 187.86 1.38-4.51s.06-.13.1-.24a.54.54 0 0 1 .22-.25l.49-.28a.11.11 0 0 1 .14 0 .25.25 0 0 1 .06.19V190a.61.61 0 0 1-.06.25.32.32 0 0 1-.14.16l-.59.35a.12.12 0 0 1-.14 0 .24.24 0 0 1 0-.18v-4.4l-1 3.08a2.35 2.35 0 0 1-.11.24.47.47 0 0 1-.16.2l-.38.22a.17.17 0 0 1-.17 0 .31.31 0 0 1-.1-.13l-1-2v4.39a.54.54 0 0 1-.06.25.41.41 0 0 1-.14.17l-.59.34h-.14a.22.22 0 0 1-.06-.18v-7.26a.61.61 0 0 1 .06-.25.35.35 0 0 1 .14-.17l.49-.28c.1-.06.17-.06.22 0l.1.12Z",
    style: {
      fill: "#455a64",
      transformOrigin: "126.9px 187.747px"
    },
    id: "eltc8h732bmvl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.28 184.84a7.86 7.86 0 0 1 .16-1.28 5.21 5.21 0 0 1 .4-1.19 5.09 5.09 0 0 1 .66-1 3.51 3.51 0 0 1 .93-.78 2 2 0 0 1 .93-.3 1 1 0 0 1 .66.28 1.7 1.7 0 0 1 .4.73 4.4 4.4 0 0 1 .16 1.1v2.01a6.89 6.89 0 0 1-.16 1.28 5.46 5.46 0 0 1-.4 1.2 4.24 4.24 0 0 1-.66 1 3.51 3.51 0 0 1-.93.78 1.79 1.79 0 0 1-.93.3.9.9 0 0 1-.66-.27 1.55 1.55 0 0 1-.4-.73 5 5 0 0 1-.16-1.1V184.84Zm3.31-1.85a1.43 1.43 0 0 0-.34-1.06c-.2-.18-.48-.17-.82 0a2.07 2.07 0 0 0-.82.92 3.44 3.44 0 0 0-.34 1.45v1.9a1.4 1.4 0 0 0 .34 1.05c.21.17.48.16.82 0a2 2 0 0 0 .82-.91 3.39 3.39 0 0 0 .34-1.44v-1c0-.39.01-.63 0-.9Z",
    style: {
      fill: "#455a64",
      transformOrigin: "132.43px 184.63px"
    },
    id: "elb8mhx7fi9li",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.86 184.83h-.19l-.1-.1-2-3.5v4.64a.53.53 0 0 1-.06.24.31.31 0 0 1-.14.17l-.59.34a.11.11 0 0 1-.14 0 .24.24 0 0 1-.06-.18v-7.27a.61.61 0 0 1 .06-.25.38.38 0 0 1 .14-.16l.51-.3c.08-.05.15-.05.19 0l.1.1 2 3.5v-4.63a.57.57 0 0 1 .06-.25.35.35 0 0 1 .14-.17l.59-.34a.11.11 0 0 1 .14 0 .24.24 0 0 1 .06.18v7.26a.57.57 0 0 1-.06.25.41.41 0 0 1-.14.17Z",
    style: {
      fill: "#455a64",
      transformOrigin: "137.575px 181.645px"
    },
    id: "eluetlsdttg4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.86 168.87a.11.11 0 0 1 .14 0 .24.24 0 0 1 .06.18v.8a.61.61 0 0 1-.06.25.49.49 0 0 1-.14.17l-1.32.76v6.16a.69.69 0 0 1 0 .24.35.35 0 0 1-.14.17l-.59.34a.1.1 0 0 1-.14 0 .24.24 0 0 1-.06-.18v-6.16l-1.32.76a.11.11 0 0 1-.14 0 .28.28 0 0 1 0-.18v-.8a.69.69 0 0 1 0-.24.35.35 0 0 1 .14-.17Z",
    style: {
      fill: "#455a64",
      transformOrigin: "151.098px 173.407px"
    },
    id: "el3lsbf958e0a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.74 166.05a.12.12 0 0 1 .14 0 .3.3 0 0 1 .05.18v4.61a6.48 6.48 0 0 1-.13 1.34 5.72 5.72 0 0 1-.39 1.19 4.63 4.63 0 0 1-.66 1 3.83 3.83 0 0 1-.91.74 1.85 1.85 0 0 1-.92.31.87.87 0 0 1-.65-.24 1.49 1.49 0 0 1-.39-.75 4.47 4.47 0 0 1-.13-1.18v-4.61a.57.57 0 0 1 .06-.25.35.35 0 0 1 .14-.17l.59-.34a.11.11 0 0 1 .14 0 .24.24 0 0 1 .06.18v4.55a3.07 3.07 0 0 0 .07.75.85.85 0 0 0 .23.4.48.48 0 0 0 .35.1 1.29 1.29 0 0 0 .45-.16 1.87 1.87 0 0 0 .45-.36 1.92 1.92 0 0 0 .35-.51 2.84 2.84 0 0 0 .23-.66 3.63 3.63 0 0 0 .08-.84v-4.55a.57.57 0 0 1 .06-.25.41.41 0 0 1 .14-.17Z",
    style: {
      fill: "#455a64",
      transformOrigin: "155.84px 170.724px"
    },
    id: "eliys5wbs56e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.44 169.8a.12.12 0 0 1 .14 0 .24.24 0 0 1 .06.18v.8a.57.57 0 0 1-.06.25.41.41 0 0 1-.14.17l-3.21 1.85a.11.11 0 0 1-.14 0 .3.3 0 0 1-.05-.18v-7.26a.7.7 0 0 1 .05-.25.41.41 0 0 1 .14-.17l3.15-1.82h.14a.24.24 0 0 1 .06.18v.8a.57.57 0 0 1-.06.25.35.35 0 0 1-.14.17l-2.38 1.37v1.79l2.2-1.27a.11.11 0 0 1 .14 0 .24.24 0 0 1 .06.18v.8a.53.53 0 0 1-.06.24.35.35 0 0 1-.14.17l-2.2 1.27v1.87Z",
    style: {
      fill: "#455a64",
      transformOrigin: "160.84px 168.223px"
    },
    id: "el9mq5shkzubm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m175 160.22-.63 3.73q0 .18-.09.33a.42.42 0 0 1-.17.2l-.59.34h-.17a.5.5 0 0 1-.09-.23l-.93-6.55v-.09a.53.53 0 0 1 .06-.24.35.35 0 0 1 .14-.17l.54-.32a.17.17 0 0 1 .14 0s.07.08.09.19l.61 4.41.54-3.31a1.42 1.42 0 0 1 .07-.25.43.43 0 0 1 .19-.23l.59-.34h.19a.47.47 0 0 1 .07.17l.54 2.69.61-5.13a.84.84 0 0 1 .09-.28.51.51 0 0 1 .14-.15l.54-.31a.11.11 0 0 1 .14 0 .22.22 0 0 1 .06.18.34.34 0 0 1 0 .09l-.93 7.64a1.5 1.5 0 0 1-.09.32.51.51 0 0 1-.17.21l-.59.34a.13.13 0 0 1-.17 0 1.1 1.1 0 0 1-.09-.23Z",
    style: {
      fill: "#455a64",
      transformOrigin: "175.007px 159.737px"
    },
    id: "el3jyrtmvc8je",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.89 158.58a.09.09 0 0 1 .13 0 .22.22 0 0 1 .06.18v.8a.53.53 0 0 1-.06.24.3.3 0 0 1-.13.17l-3.21 1.85a.11.11 0 0 1-.14 0 .22.22 0 0 1-.06-.18v-7.26a.61.61 0 0 1 .06-.25.41.41 0 0 1 .14-.17l3.15-1.81a.11.11 0 0 1 .14 0s.05.09.05.18v.79a.53.53 0 0 1-.05.25.41.41 0 0 1-.14.17l-2.36 1.36v1.79l2.2-1.27a.12.12 0 0 1 .14 0 .3.3 0 0 1 .05.18v.8a.74.74 0 0 1-.05.25.41.41 0 0 1-.14.17l-2.2 1.27V160Z",
    style: {
      fill: "#455a64",
      transformOrigin: "180.28px 156.985px"
    },
    id: "el3z27617qw7p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185 150.32a1.94 1.94 0 0 1 .94-.32.87.87 0 0 1 .66.24 1.55 1.55 0 0 1 .41.74 4.84 4.84 0 0 1 .17 1.18v1.67a7.66 7.66 0 0 1-.17 1.38 5.54 5.54 0 0 1-.4 1.21 4.56 4.56 0 0 1-.66 1 3.47 3.47 0 0 1-.91.75l-1.84 1.06h-.14a.23.23 0 0 1-.06-.23v-7.26a.57.57 0 0 1 .06-.25.35.35 0 0 1 .14-.17Zm1.2 2.41a2.62 2.62 0 0 0-.09-.61.85.85 0 0 0-.23-.41.52.52 0 0 0-.38-.15 1.3 1.3 0 0 0-.54.19l-1 .56v5.06l1-.58a2.17 2.17 0 0 0 .52-.43 2.39 2.39 0 0 0 .36-.57 2.78 2.78 0 0 0 .23-.67 4.43 4.43 0 0 0 .09-.72c.05-.57.05-1.12.03-1.67Z",
    style: {
      fill: "#455a64",
      transformOrigin: "185.085px 154.614px"
    },
    id: "elxsq4bavm5o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.21 141.53h.14a.23.23 0 0 1 .06.18v.8a.53.53 0 0 1-.06.24.31.31 0 0 1-.14.17l-1.31.76v6.16a.54.54 0 0 1-.06.25.41.41 0 0 1-.14.17l-.59.34a.11.11 0 0 1-.14 0 .22.22 0 0 1-.06-.18v-6.16l-1.31.76h-.14a.24.24 0 0 1-.06-.18V144a.53.53 0 0 1 .06-.24.31.31 0 0 1 .14-.17Z",
    style: {
      fill: "#455a64",
      transformOrigin: "198.405px 146.078px"
    },
    id: "elmzoib1az8xi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.12 138.7a.12.12 0 0 1 .14 0 .24.24 0 0 1 .06.18v7.27a.61.61 0 0 1-.06.25.41.41 0 0 1-.14.17l-.59.34a.11.11 0 0 1-.14 0 .24.24 0 0 1-.06-.18v-3l-2.2 1.27v3a.57.57 0 0 1-.06.25.41.41 0 0 1-.14.17l-.59.34h-.14a.22.22 0 0 1-.06-.18v-7.28a.54.54 0 0 1 .06-.25.35.35 0 0 1 .14-.17l.59-.34a.11.11 0 0 1 .14 0 .24.24 0 0 1 .06.18v2.89l2.2-1.28v-2.89a.53.53 0 0 1 .06-.24.35.35 0 0 1 .14-.17Z",
    style: {
      fill: "#455a64",
      transformOrigin: "203.23px 143.719px"
    },
    id: "elozezvo3bmq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.41 135.64a.11.11 0 0 1 .14 0 .3.3 0 0 1 .06.18v4.61a6.48 6.48 0 0 1-.14 1.34 5.19 5.19 0 0 1-.39 1.19 4.63 4.63 0 0 1-.66 1 3.83 3.83 0 0 1-.91.74 2 2 0 0 1-.92.31.87.87 0 0 1-.65-.24 1.49 1.49 0 0 1-.39-.75 4.47 4.47 0 0 1-.13-1.18v-4.61a.57.57 0 0 1 .06-.25.35.35 0 0 1 .14-.17l.59-.34a.11.11 0 0 1 .14 0 .24.24 0 0 1 .06.18v4.55a2.48 2.48 0 0 0 .08.74.88.88 0 0 0 .22.41.48.48 0 0 0 .35.1 1.29 1.29 0 0 0 .45-.16 2.54 2.54 0 0 0 .49-.29 1.92 1.92 0 0 0 .35-.51 2.44 2.44 0 0 0 .23-.66 3.61 3.61 0 0 0 .09-.84v-4.59a.53.53 0 0 1 .05-.25.41.41 0 0 1 .14-.17Z",
    style: {
      fill: "#455a64",
      transformOrigin: "208.514px 140.313px"
    },
    id: "elae701ieckdg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.77 126.78a.1.1 0 0 1 .13 0 .24.24 0 0 1 .06.18v.8a.57.57 0 0 1-.06.25.34.34 0 0 1-.13.17l-2.33 1.34v2.19l2.18-1.27a.11.11 0 0 1 .14 0 .22.22 0 0 1 .06.18v.79a.54.54 0 0 1-.06.25.41.41 0 0 1-.14.17l-2.18 1.26v2.58a.53.53 0 0 1-.06.24.35.35 0 0 1-.14.17l-.59.34a.1.1 0 0 1-.14 0 .21.21 0 0 1-.06-.17V129a.61.61 0 0 1 .06-.25.4.4 0 0 1 .14-.17Z",
    style: {
      fill: "#455a64",
      transformOrigin: "224.205px 131.602px"
    },
    id: "el8l0f1mjo275",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.89 125c.61-.35 1.07-.4 1.39-.15a1.9 1.9 0 0 1 .47 1.54 4.87 4.87 0 0 1-.24 1.54 3.71 3.71 0 0 1-.72 1.27l1 2.2a.43.43 0 0 1 0 .11.49.49 0 0 1 0 .2.33.33 0 0 1-.11.14l-.62.36c-.1.05-.17.06-.22 0a.94.94 0 0 1-.1-.14l-.95-2.07-1 .56v2.62a.61.61 0 0 1-.06.25.41.41 0 0 1-.14.17l-.59.34h-.14a.24.24 0 0 1-.06-.18v-7.27a.53.53 0 0 1 .06-.24.35.35 0 0 1 .14-.17Zm-1.09 4.17 1-.61a2 2 0 0 0 .67-.61 1.77 1.77 0 0 0 .25-1c0-.42-.09-.66-.25-.7a.91.91 0 0 0-.67.17l-1 .61Z",
    style: {
      fill: "#455a64",
      transformOrigin: "228.8px 129.317px"
    },
    id: "eljekbwqxh4x7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.9 131.11a.11.11 0 0 1-.14 0 .23.23 0 0 1-.06-.18v-7.26a.57.57 0 0 1 .06-.25.41.41 0 0 1 .14-.17l.59-.34a.11.11 0 0 1 .14 0 .24.24 0 0 1 .06.18v7.26a.54.54 0 0 1-.06.25.41.41 0 0 1-.14.17Z",
    style: {
      fill: "#455a64",
      transformOrigin: "232.195px 127.01px"
    },
    id: "ell9xv0wgjkoq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.06 114.37a2 2 0 0 1 .86-.29 1 1 0 0 1 .62.15 1.12 1.12 0 0 1 .38.45 1.81 1.81 0 0 1 .14.61.54.54 0 0 1-.06.25.41.41 0 0 1-.14.17l-.51.29a.21.21 0 0 1-.19 0 .36.36 0 0 1-.11-.13.54.54 0 0 0-.33-.3.87.87 0 0 0-.66.17 1.54 1.54 0 0 0-.36.27 1.69 1.69 0 0 0-.3.36 1.59 1.59 0 0 0-.28.82.75.75 0 0 0 .07.38.31.31 0 0 0 .24.15 1.36 1.36 0 0 0 .43 0l.67-.15a2.48 2.48 0 0 1 .76-.1.88.88 0 0 1 .52.18 1 1 0 0 1 .3.46 2.68 2.68 0 0 1 .09.76 3.58 3.58 0 0 1-.14 1 4.34 4.34 0 0 1-.42 1 4.54 4.54 0 0 1-.66.87 4.25 4.25 0 0 1-.89.69 2.23 2.23 0 0 1-.78.3 1.19 1.19 0 0 1-.66-.06.93.93 0 0 1-.46-.42 1.64 1.64 0 0 1-.2-.79.56.56 0 0 1 0-.25.39.39 0 0 1 .15-.16l.51-.3a.21.21 0 0 1 .19 0 .24.24 0 0 1 .11.14 1.19 1.19 0 0 0 .12.22.35.35 0 0 0 .2.14.63.63 0 0 0 .31 0 1.42 1.42 0 0 0 .46-.2 3 3 0 0 0 .43-.29 2.11 2.11 0 0 0 .35-.38 1.56 1.56 0 0 0 .25-.43 1.16 1.16 0 0 0 .1-.49.54.54 0 0 0-.1-.35.48.48 0 0 0-.31-.09 3.34 3.34 0 0 0-.52.09l-.71.15a2.46 2.46 0 0 1-.64 0 .78.78 0 0 1-.45-.2 1 1 0 0 1-.27-.48 3.59 3.59 0 0 1-.08-.82 4 4 0 0 1 .14-1 4.34 4.34 0 0 1 1-1.79 3.44 3.44 0 0 1 .83-.6Z",
    style: {
      fill: "#455a64",
      transformOrigin: "247.088px 118.414px"
    },
    id: "el6ceuimg3vh3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.37 111.42h.17a.5.5 0 0 1 .1.23l1.79 6.07a.15.15 0 0 1 0 .07.57.57 0 0 1-.06.25.35.35 0 0 1-.14.17l-.52.3q-.15.09-.21 0a.5.5 0 0 1-.08-.14l-.31-1.07-2.31 1.33-.31 1.43c0 .07-.05.15-.08.23a.49.49 0 0 1-.21.22l-.52.3h-.14a.24.24 0 0 1-.06-.18.19.19 0 0 1 0-.08l1.79-8.14a1.23 1.23 0 0 1 .1-.35.45.45 0 0 1 .17-.19Zm.4 4.71-.81-2.74-.8 3.66Z",
    style: {
      fill: "#455a64",
      transformOrigin: "251.955px 116.115px"
    },
    id: "elgfgbwm2dobw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258 108.18a.11.11 0 0 1 .14 0 .22.22 0 0 1 .06.18v.79a.54.54 0 0 1-.06.25.41.41 0 0 1-.14.17l-1.32.76v6.16a.56.56 0 0 1-.05.25.41.41 0 0 1-.14.17l-.59.34h-.14a.24.24 0 0 1-.06-.18v-6.16l-1.32.76a.09.09 0 0 1-.13 0 .24.24 0 0 1-.06-.18v-.8a.61.61 0 0 1 .06-.25.34.34 0 0 1 .13-.17Z",
    style: {
      fill: "#455a64",
      transformOrigin: "256.195px 112.702px"
    },
    id: "elmez3qesqayh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.08 101.08a1.78 1.78 0 0 1 .86-.29 1.08 1.08 0 0 1 .62.14 1 1 0 0 1 .38.45 1.87 1.87 0 0 1 .14.61.51.51 0 0 1-.05.25.37.37 0 0 1-.15.17l-.51.3c-.08 0-.14.06-.18 0s-.08-.07-.12-.13a.61.61 0 0 0-.33-.3.89.89 0 0 0-.66.18 1.54 1.54 0 0 0-.36.27 1.43 1.43 0 0 0-.3.35 1.66 1.66 0 0 0-.2.4 1.26 1.26 0 0 0-.08.43.88.88 0 0 0 .07.38.34.34 0 0 0 .24.15 1.42 1.42 0 0 0 .43 0c.18 0 .41-.08.67-.15a2.82 2.82 0 0 1 .76-.09.87.87 0 0 1 .52.17 1 1 0 0 1 .3.46 2.72 2.72 0 0 1 .1.77 3.71 3.71 0 0 1-.15 1 4.46 4.46 0 0 1-.42 1 4.93 4.93 0 0 1-.66.88 4.19 4.19 0 0 1-.88.69 2.55 2.55 0 0 1-.79.29 1.12 1.12 0 0 1-.66 0 1 1 0 0 1-.46-.43 1.72 1.72 0 0 1-.2-.78.54.54 0 0 1 .06-.25.41.41 0 0 1 .14-.17l.51-.29c.08 0 .15-.07.19 0a.27.27 0 0 1 .11.14 1.55 1.55 0 0 0 .12.22.43.43 0 0 0 .2.15.54.54 0 0 0 .31 0 1.39 1.39 0 0 0 .47-.19 2.73 2.73 0 0 0 .42-.3 2.1 2.1 0 0 0 .36-.37 2.38 2.38 0 0 0 .25-.44 1.28 1.28 0 0 0 .09-.48.47.47 0 0 0-.1-.35.41.41 0 0 0-.31-.09 3.16 3.16 0 0 0-.52.08l-.71.15a2 2 0 0 1-.63 0 .77.77 0 0 1-.46-.19.93.93 0 0 1-.26-.48 3.1 3.1 0 0 1-.09-.82 4 4 0 0 1 .14-1 4.55 4.55 0 0 1 .41-1 4.13 4.13 0 0 1 .61-.83 3.14 3.14 0 0 1 .76-.66Z",
    style: {
      fill: "#455a64",
      transformOrigin: "270.12px 105.148px"
    },
    id: "el9hhdabaf95s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277 97.19a.12.12 0 0 1 .14 0 .24.24 0 0 1 .06.18V102a7.25 7.25 0 0 1-.13 1.34 5.21 5.21 0 0 1-.4 1.19 3.78 3.78 0 0 1-.66 1 3.47 3.47 0 0 1-.91.75 2 2 0 0 1-.92.31.86.86 0 0 1-.65-.25 1.57 1.57 0 0 1-.39-.74 4.47 4.47 0 0 1-.13-1.18V99.8a.57.57 0 0 1 .06-.25.41.41 0 0 1 .14-.17l.59-.34a.11.11 0 0 1 .14 0 .24.24 0 0 1 .06.18v4.55a2.87 2.87 0 0 0 .08.74.88.88 0 0 0 .22.41.5.5 0 0 0 .36.1 1.32 1.32 0 0 0 .44-.16 2.54 2.54 0 0 0 .45-.36 1.71 1.71 0 0 0 .35-.51 2.44 2.44 0 0 0 .23-.66 3.61 3.61 0 0 0 .09-.84V98a.54.54 0 0 1 .06-.25.35.35 0 0 1 .14-.17Z",
    style: {
      fill: "#455a64",
      transformOrigin: "275.105px 101.879px"
    },
    id: "elrkeemzahge",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.62 102.4h-.19l-.09-.11-2-3.49v4.63a.61.61 0 0 1-.06.25.41.41 0 0 1-.14.17l-.59.34h-.14a.24.24 0 0 1-.06-.18v-7.26a.54.54 0 0 1 .06-.25.35.35 0 0 1 .14-.17L279 96h.19l.09.11 2.05 3.49V95a.61.61 0 0 1 .06-.25.39.39 0 0 1 .13-.17l.6-.34a.09.09 0 0 1 .13 0 .24.24 0 0 1 .06.18v7.27a.53.53 0 0 1-.06.24.3.3 0 0 1-.13.17Z",
    style: {
      fill: "#455a64",
      transformOrigin: "280.33px 99.2011px"
    },
    id: "elhhyru2e8xl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.77 169.92a.43.43 0 0 1-.22-.8l162-93.55a.43.43 0 0 1 .43.75L123 169.87a.38.38 0 0 1-.23.05Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "203.768px 122.717px"
    },
    id: "el84icgyc7b1e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.68 120.68a.88.88 0 0 1-.19-.24l-1.27-2.71v6.92a1.07 1.07 0 0 1-.11.46.73.73 0 0 1-.26.32l-1.78 1a.2.2 0 0 1-.26 0 .45.45 0 0 1-.11-.33v-13.51a1.07 1.07 0 0 1 .11-.46.67.67 0 0 1 .26-.32l1.57-.91c.19-.11.32-.11.41 0a1.22 1.22 0 0 1 .18.24l2.2 4.52 2.2-7.07c0-.08.09-.23.18-.43a1 1 0 0 1 .41-.47l1.58-.91a.18.18 0 0 1 .25 0 .41.41 0 0 1 .11.33v13.52a1 1 0 0 1-.11.46.72.72 0 0 1-.25.32l-1.79 1a.18.18 0 0 1-.25 0 .41.41 0 0 1-.11-.33v-6.93l-1.28 4.19q-.08.21-.18.45a.87.87 0 0 1-.32.36l-.87.51c-.14.09-.25.1-.32.02Z",
    style: {
      fill: "#455a64",
      transformOrigin: "184.431px 116.604px"
    },
    id: "el4xxn67249xy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.09 102.56c.19-.11.32-.11.42 0a.9.9 0 0 1 .2.34l3 11.48a.87.87 0 0 1 .05.28 1 1 0 0 1-.08.38.5.5 0 0 1-.22.25l-1.71 1c-.18.11-.31.12-.39 0a.55.55 0 0 1-.14-.26l-.38-1.52-3.61 2.09-.38 2a1.58 1.58 0 0 1-.15.43.88.88 0 0 1-.39.4l-1.71 1a.16.16 0 0 1-.21 0 .38.38 0 0 1-.09-.28 1.61 1.61 0 0 1 .06-.34l3-14.9a2.8 2.8 0 0 1 .2-.57 1 1 0 0 1 .41-.47Zm-2.2 10.44 2.2-1.27-1.1-4.39Z",
    style: {
      fill: "#455a64",
      transformOrigin: "195.029px 111.473px"
    },
    id: "elve7yfhzmmua",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.88 97.49a4.8 4.8 0 0 1 1.6-.64 1.75 1.75 0 0 1 1.2.19 1.87 1.87 0 0 1 .76 1.06 6 6 0 0 1 .27 2 9.17 9.17 0 0 1-.42 2.85 7.47 7.47 0 0 1-1.2 2.27l1.69 4a.78.78 0 0 1 0 .21.81.81 0 0 1-.09.37.52.52 0 0 1-.21.26l-1.85 1.07c-.18.11-.31.12-.39 0a1 1 0 0 1-.18-.28l-1.51-3.6-1.25.72v4.48a1.11 1.11 0 0 1-.11.46.72.72 0 0 1-.26.32l-1.78 1a.2.2 0 0 1-.26 0 .44.44 0 0 1-.11-.33v-13.51a1.11 1.11 0 0 1 .11-.46.79.79 0 0 1 .26-.32Zm-1.54 7.23 1.54-.89a2.82 2.82 0 0 0 .94-.88 2.51 2.51 0 0 0 .37-1.43c0-.59-.12-.92-.37-1a1.19 1.19 0 0 0-.94.21l-1.54.89Z",
    style: {
      fill: "#455a64",
      transformOrigin: "204.783px 105.547px"
    },
    id: "elohctrnardkn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.46 98.67v3.52a5.27 5.27 0 0 0 .12.85 1.41 1.41 0 0 0 .3.6.73.73 0 0 0 .52.24 1.43 1.43 0 0 0 .77-.25 2.79 2.79 0 0 0 .76-.61 3.12 3.12 0 0 0 .49-.69 3.51 3.51 0 0 0 .3-.7c.06-.24.12-.45.15-.64a3.36 3.36 0 0 1 .15-.55.79.79 0 0 1 .31-.32l1.79-1a.17.17 0 0 1 .21 0 .4.4 0 0 1 .08.27 8.3 8.3 0 0 1-.34 2.21 9.85 9.85 0 0 1-.89 2.15 10.42 10.42 0 0 1-1.34 1.87 6.88 6.88 0 0 1-1.67 1.37 3.62 3.62 0 0 1-1.74.56 2 2 0 0 1-1.32-.47 2.89 2.89 0 0 1-.83-1.33 6.63 6.63 0 0 1-.33-2v-3.73a10.3 10.3 0 0 1 .32-2.37 11.28 11.28 0 0 1 .84-2.3 9.45 9.45 0 0 1 1.31-2 6.91 6.91 0 0 1 1.75-1.46 3.64 3.64 0 0 1 1.67-.55 2.21 2.21 0 0 1 1.34.32 2.32 2.32 0 0 1 .89 1.12 4.64 4.64 0 0 1 .34 1.81 1 1 0 0 1-.08.37.52.52 0 0 1-.21.26l-1.79 1c-.15.09-.25.1-.31 0a1.2 1.2 0 0 1-.15-.39 2.64 2.64 0 0 0-.15-.45.85.85 0 0 0-.3-.37.75.75 0 0 0-.49-.12 1.66 1.66 0 0 0-.76.27 3 3 0 0 0-.77.64 3.81 3.81 0 0 0-.52.84 4.91 4.91 0 0 0-.3.94 8.36 8.36 0 0 0-.12 1.09Z",
    style: {
      fill: "#455a64",
      transformOrigin: "214.181px 99.4413px"
    },
    id: "elocdf6vpsnj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.49 84.43a.2.2 0 0 1 .26 0 .41.41 0 0 1 .11.33V98.3a1 1 0 0 1-.11.46.72.72 0 0 1-.26.32l-1.78 1a.19.19 0 0 1-.25 0 .42.42 0 0 1-.11-.34v-5.12l-3 1.75v5.12a1.15 1.15 0 0 1-.11.47.68.68 0 0 1-.26.31l-1.78 1a.21.21 0 0 1-.26 0 .45.45 0 0 1-.11-.34v-13.5a1.07 1.07 0 0 1 .11-.46.73.73 0 0 1 .26-.32l1.78-1a.2.2 0 0 1 .26 0 .46.46 0 0 1 .11.34v5l3-1.74v-5a1 1 0 0 1 .11-.46.62.62 0 0 1 .25-.31Z",
    style: {
      fill: "#455a64",
      transformOrigin: "223.845px 93.8485px"
    },
    id: "elddmmhcnli3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m127.74 151.24 2.66 1.22a1.15 1.15 0 0 1 .24.18.52.52 0 0 1 .13.4v1.54a.7.7 0 0 1-.07.31.46.46 0 0 1-.17.21h-.13l-4.12-1.9a.58.58 0 0 1-.25-.17.62.62 0 0 1-.09-.39v-.76a1.28 1.28 0 0 1 .09-.5 3.66 3.66 0 0 1 .25-.46l4.12-6.65.07-.09h.06a.13.13 0 0 1 .17 0 .3.3 0 0 1 .07.23v1.54a1.19 1.19 0 0 1-.13.54 5 5 0 0 1-.24.47Z",
    style: {
      fill: "#455a64",
      transformOrigin: "128.355px 149.624px"
    },
    id: "elzvaij11zh8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.37 63.8a1.19 1.19 0 0 1-.25-.18.56.56 0 0 1-.13-.4v-1.54a.87.87 0 0 1 .07-.31.48.48 0 0 1 .18-.21h.13l4.11 1.9a.56.56 0 0 1 .26.17.62.62 0 0 1 .09.39v.76a1.19 1.19 0 0 1-.09.49 2.88 2.88 0 0 1-.26.47L274.37 72a.49.49 0 0 1-.08.1s0 0-.05 0a.14.14 0 0 1-.18 0 .35.35 0 0 1-.07-.23v-1.55a1.42 1.42 0 0 1 .13-.55c.09-.18.17-.33.25-.47L277 65Z",
    style: {
      fill: "#455a64",
      transformOrigin: "276.411px 66.6464px"
    },
    id: "eliao4mga0xnl",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Button--inject-56",
    className: "animable",
    style: {
      transformOrigin: "137.369px 86.2578px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M169.06 62.43a2.52 2.52 0 0 0-1-2.31l-5.58-3.21a2.48 2.48 0 0 0-2.52.25l-50.72 29.27a7.87 7.87 0 0 0-3.56 6.17v17.49a2.5 2.5 0 0 0 1 2.31l5.57 3.21a2.49 2.49 0 0 0 2.51-.25l50.7-29.27a7.87 7.87 0 0 0 3.56-6.17Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "137.369px 86.2578px"
    },
    id: "el7yluzv8i00k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.36 115.64a.09.09 0 0 1-.07 0l-5.57-3.22a2.49 2.49 0 0 1-1-2.3V92.6a6.82 6.82 0 0 1 .74-2.92l5.54 3.21a7.06 7.06 0 0 0-.72 2.93v17.49a2.43 2.43 0 0 0 1.08 2.33Z",
    style: {
      opacity: 0.2,
      transformOrigin: "109.031px 102.664px"
    },
    className: "animable",
    id: "elfjp0ac9bld8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.86 60a2.64 2.64 0 0 0-2.35.34l-50.7 29.28a7.6 7.6 0 0 0-2.81 3.27l-5.54-3.21a7.55 7.55 0 0 1 2.8-3.25l50.7-29.28a2.53 2.53 0 0 1 2.52-.24c.57.34 4.38 2.53 5.38 3.09Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      transformOrigin: "137.16px 74.7854px"
    },
    className: "animable",
    id: "el2p9m8cwmmqt"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-56",
    className: "animable",
    style: {
      transformOrigin: "83.469px 377.698px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--plant--inject-56",
    className: "animable",
    style: {
      transformOrigin: "83.469px 377.698px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--pot--inject-56",
    className: "animable",
    style: {
      transformOrigin: "86.1275px 413.141px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "86.1275px 413.141px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.71 438.32C54.79 427 48.37 398.69 59 389.75h54.23c10.66 8.94 4.25 37.27-6.67 48.56-.1.1-.21.2-.3.31l-.38.37c-.31.3-.64.6-1 .89l-.26.2c-.27.22-.53.43-.82.63a14.88 14.88 0 0 1-1.42.92c-9 5.24-23.56 5.24-32.55 0-.48-.27-1-.59-1.43-.92-.27-.19-.51-.39-.76-.59l-.33-.26c-.34-.28-.65-.56-.95-.85l-.43-.43Z",
    style: {
      fill: "#37474f",
      transformOrigin: "86.1275px 417.655px"
    },
    id: "el2emgi70jpg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.55 386.14c12.38 7.23 12.38 18.94 0 26.17s-32.44 7.22-44.81 0-12.38-18.94 0-26.17 32.44-7.22 44.81 0Z",
    style: {
      fill: "#455a64",
      transformOrigin: "86.1469px 399.225px"
    },
    id: "el0tfa7t272bs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.6 389.62c9.09 5.3 9.09 13.91 0 19.21s-23.82 5.31-32.91 0-9.09-13.91 0-19.21 23.82-5.31 32.91 0Z",
    style: {
      fill: "#263238",
      transformOrigin: "86.145px 399.225px"
    },
    id: "elqdeii8ic1gq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.69 398.74c9.09-5.31 23.82-5.31 32.91 0a15 15 0 0 1 5.44 5.05 15 15 0 0 1-5.44 5c-9.09 5.31-23.82 5.31-32.91 0a15.13 15.13 0 0 1-5.44-5 15.06 15.06 0 0 1 5.44-5.05Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "86.145px 403.765px"
    },
    id: "elfmjafrud3sk",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Leaves--inject-56",
    className: "animable",
    style: {
      transformOrigin: "83.469px 359.65px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.06 326.06c2.78 4.58-.5 12.71-8 14.45 2.23-3.41 4.08-8.66 2.16-9.3s.47 4.1-3.56 8.74c0 0-2.22 1.16-5.45-1.27 4.55-3.45 6.39-10.33 4.76-9.32-.65.41-1.67 3.83-4.39 6.05s-5.52 2.47-9.81-.9c2.5-.51 6.08-1.62 8.06-4.25 1.43-1.89 1.84-3.08-1.52-.84s-4.42 3.18-7.68 3.17-6.21-3.31-6.21-3.31 5.35.33 6.51-1.42-4.37 1-8.12-.41a21.56 21.56 0 0 1-6.29-3.65s1.61-4.3 2.82-5.38c2.85 2 6.42 4.79 6.93 4.17s-.69-2.82-4.88-4.71a3.57 3.57 0 0 1 3.23-2.68s2.12.24 5.45 5.65c.7 1.14 2.2 2.12-.53-2.24-2.26-3.63-4.2-4.76-4.2-4.76a5.62 5.62 0 0 1 7 .43c6.23 4.91 6.55 7.44 7.42 7 .32-.15-.19-1.46-2.59-4.57a19.43 19.43 0 0 0-4.42-4.4s2.49-3.1 6.83-.44 7.06 8.44 7.36 8.54c.78.24-.54-4.39-2.31-6.86-1.65-2.3-2.55-3.34-2.55-3.34a6.27 6.27 0 0 1 7.16 2.15c3.2 3.85 2.93 9.68 3.91 9.36S68 312.28 68 312.28s9.18 7.83 4.06 13.78Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "53.0665px 325.173px"
    },
    id: "el3dqbapgmj44",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.06 326.06c2.78 4.58-.5 12.71-8 14.45 2.23-3.41 4.08-8.66 2.16-9.3s.47 4.1-3.56 8.74c0 0-2.22 1.16-5.45-1.27 4.55-3.45 6.39-10.33 4.76-9.32-.65.41-1.67 3.83-4.39 6.05s-5.52 2.47-9.81-.9c2.5-.51 6.08-1.62 8.06-4.25 1.43-1.89 1.84-3.08-1.52-.84s-4.42 3.18-7.68 3.17-6.21-3.31-6.21-3.31 5.35.33 6.51-1.42-4.37 1-8.12-.41a21.56 21.56 0 0 1-6.29-3.65s1.61-4.3 2.82-5.38c2.85 2 6.42 4.79 6.93 4.17s-.69-2.82-4.88-4.71a3.57 3.57 0 0 1 3.23-2.68s2.12.24 5.45 5.65c.7 1.14 2.2 2.12-.53-2.24-2.26-3.63-4.2-4.76-4.2-4.76a5.62 5.62 0 0 1 7 .43c6.23 4.91 6.55 7.44 7.42 7 .32-.15-.19-1.46-2.59-4.57a19.43 19.43 0 0 0-4.42-4.4s2.49-3.1 6.83-.44 7.06 8.44 7.36 8.54c.78.24-.54-4.39-2.31-6.86-1.65-2.3-2.55-3.34-2.55-3.34a6.27 6.27 0 0 1 7.16 2.15c3.2 3.85 2.93 9.68 3.91 9.36S68 312.28 68 312.28s9.18 7.83 4.06 13.78Z",
    style: {
      opacity: 0.2,
      transformOrigin: "53.0665px 325.173px"
    },
    className: "animable",
    id: "elzial87dorfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.08 319.46a9.45 9.45 0 0 1 6.13-5.12 6.73 6.73 0 0 1 7.21 2.75c.1.17 0 .54-.19.29-1.76-2.41-4.93-2.48-7.53-1.54-2.75 1-4.45 3.5-5.39 6.18a34 34 0 0 0-1.45 9.09 77.41 77.41 0 0 0 .06 9.87c.86 13.16 4.44 26 7.22 38.8 1.56 7.22 2.29 21.53 2.86 28.86 0 .65-1 1.27-1 .38-1.4-14.56-5.08-35.73-7.9-50a122.26 122.26 0 0 1-2.59-21.13c-.2-5.98-.25-13 2.57-18.43Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "83.4441px 361.8px"
    },
    id: "elpfletaftuvk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.08 319.46a9.45 9.45 0 0 1 6.13-5.12 6.73 6.73 0 0 1 7.21 2.75c.1.17 0 .54-.19.29-1.76-2.41-4.93-2.48-7.53-1.54-2.75 1-4.45 3.5-5.39 6.18a34 34 0 0 0-1.45 9.09 77.41 77.41 0 0 0 .06 9.87c.86 13.16 4.44 26 7.22 38.8 1.56 7.22 2.29 21.53 2.86 28.86 0 .65-1 1.27-1 .38-1.4-14.56-5.08-35.73-7.9-50a122.26 122.26 0 0 1-2.59-21.13c-.2-5.98-.25-13 2.57-18.43Z",
    style: {
      opacity: 0.6,
      transformOrigin: "83.4441px 361.8px"
    },
    className: "animable",
    id: "ela0kdgm3hz55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70 333.08c6.25.05 11.26 4.82 14.22 9.92 3.38 5.82 5.42 12.56 7 19.05a120.82 120.82 0 0 1 3.27 21.73 73.79 73.79 0 0 1 0 11.42c-.34 3.66-.9 8-3 11.1-.17.26-.37-.22-.33-.36.7-3.09 1.67-6 2.07-9.18a60.67 60.67 0 0 0 .34-9.24 120 120 0 0 0-2.2-19.26 101.47 101.47 0 0 0-5.45-18.55c-2.19-5.39-5.26-10.83-10.63-13.57a12.06 12.06 0 0 0-9.27-1 9.31 9.31 0 0 0-6.19 6.44c0 .21-.26 0-.24-.17A10.26 10.26 0 0 1 70 333.08Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "77.1501px 369.725px"
    },
    id: "elhblbtv9zt1m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70 333.08c6.25.05 11.26 4.82 14.22 9.92 3.38 5.82 5.42 12.56 7 19.05a120.82 120.82 0 0 1 3.27 21.73 73.79 73.79 0 0 1 0 11.42c-.34 3.66-.9 8-3 11.1-.17.26-.37-.22-.33-.36.7-3.09 1.67-6 2.07-9.18a60.67 60.67 0 0 0 .34-9.24 120 120 0 0 0-2.2-19.26 101.47 101.47 0 0 0-5.45-18.55c-2.19-5.39-5.26-10.83-10.63-13.57a12.06 12.06 0 0 0-9.27-1 9.31 9.31 0 0 0-6.19 6.44c0 .21-.26 0-.24-.17A10.26 10.26 0 0 1 70 333.08Z",
    style: {
      opacity: 0.5,
      transformOrigin: "77.1501px 369.725px"
    },
    className: "animable",
    id: "el1vmf31nx9mp"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.59 378.88c-2-7.39-4.49-15-9.59-20.82a24.27 24.27 0 0 0-4.51-4.06c-1.51-1.05-3.3-2.35-5.18-2.57-.21 0-.23.41-.1.5a50.74 50.74 0 0 1 5.45 3.92 29.63 29.63 0 0 1 4.13 4.81 52.81 52.81 0 0 1 6.12 13.17 135.51 135.51 0 0 1 4 14.28c1.13 5.17 2 10.37 2.87 15.58 0 .25.3.2.31 0 .19-8.38-1.39-16.8-3.5-24.81Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "68.617px 377.645px"
    },
    id: "el0ft77bge4ig8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.59 378.88c-2-7.39-4.49-15-9.59-20.82a24.27 24.27 0 0 0-4.51-4.06c-1.51-1.05-3.3-2.35-5.18-2.57-.21 0-.23.41-.1.5a50.74 50.74 0 0 1 5.45 3.92 29.63 29.63 0 0 1 4.13 4.81 52.81 52.81 0 0 1 6.12 13.17 135.51 135.51 0 0 1 4 14.28c1.13 5.17 2 10.37 2.87 15.58 0 .25.3.2.31 0 .19-8.38-1.39-16.8-3.5-24.81Z",
    style: {
      opacity: 0.6,
      transformOrigin: "68.617px 377.645px"
    },
    className: "animable",
    id: "elwqkxjnp9vjg"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.71 356.83c2.11-3.51 10.51-6.85 22.21-3.24A32.24 32.24 0 0 1 131.3 360c-7.68-2.15-18.08-4.22-19.52-1.54s3 2.12 7.08 1.9c8.83-.49 13.83.94 13.83.94a24 24 0 0 1 7.75 9.6c-7.29-5.62-17.19-7.29-21.67-6.48s-4.93 2.57-1.34 2.51 10.66-.44 25.79 8.4c0 0 2.63 3.32 1.74 10.48-2.2-3.56-6.2-6-9.76-8a53.12 53.12 0 0 0-11.4-5.08c-.71-.2-2.14-.57-2.74.06s-.07 1.62.5 2.08a13.85 13.85 0 0 0 4.1 2c1.89.62 3.74 1.46 5.57 2.26a58.93 58.93 0 0 1 8.9 4.41c1.51 1 3.54 6.42 1.76 11.23-3.81-2-10.75-9.68-16.9-11s.54 2.09 4.91 5.48c3.76 2.92 10.36 8.78 10.36 8.78a101.67 101.67 0 0 1-6.12 11.42 38.74 38.74 0 0 1-12.48-3.92s-.23-12.84-2.82-14.86-1.78 3.32-.47 8.19 1.59 6.66 1.59 6.66-12.75-1.66-16.38-7.25c.63-2.51 3-8.81 4.48-13.05 1.52-4.46 3.74-7.89 2.63-9.11s-3.58 1.94-5.81 6.07a52.09 52.09 0 0 0-4.48 13.27s-7.94-4.3-10.07-7.64c-1-8.24 5.55-15.17 6.79-16.13s.69-5.48-5.28-1.45a13.15 13.15 0 0 0-6 11s-6-2.57-6.81-8.67c-1.39-9.85 4.91-17.48 18.68-15.73Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "111.993px 380.742px"
    },
    id: "elilz15uwql4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.71 356.83c2.11-3.51 10.51-6.85 22.21-3.24A32.24 32.24 0 0 1 131.3 360c-7.68-2.15-18.08-4.22-19.52-1.54s3 2.12 7.08 1.9c8.83-.49 13.83.94 13.83.94a24 24 0 0 1 7.75 9.6c-7.29-5.62-17.19-7.29-21.67-6.48s-4.93 2.57-1.34 2.51 10.66-.44 25.79 8.4c0 0 2.63 3.32 1.74 10.48-2.2-3.56-6.2-6-9.76-8a53.12 53.12 0 0 0-11.4-5.08c-.71-.2-2.14-.57-2.74.06s-.07 1.62.5 2.08a13.85 13.85 0 0 0 4.1 2c1.89.62 3.74 1.46 5.57 2.26a58.93 58.93 0 0 1 8.9 4.41c1.51 1 3.54 6.42 1.76 11.23-3.81-2-10.75-9.68-16.9-11s.54 2.09 4.91 5.48c3.76 2.92 10.36 8.78 10.36 8.78a101.67 101.67 0 0 1-6.12 11.42 38.74 38.74 0 0 1-12.48-3.92s-.23-12.84-2.82-14.86-1.78 3.32-.47 8.19 1.59 6.66 1.59 6.66-12.75-1.66-16.38-7.25c.63-2.51 3-8.81 4.48-13.05 1.52-4.46 3.74-7.89 2.63-9.11s-3.58 1.94-5.81 6.07a52.09 52.09 0 0 0-4.48 13.27s-7.94-4.3-10.07-7.64c-1-8.24 5.55-15.17 6.79-16.13s.69-5.48-5.28-1.45a13.15 13.15 0 0 0-6 11s-6-2.57-6.81-8.67c-1.39-9.85 4.91-17.48 18.68-15.73Z",
    style: {
      opacity: 0.2,
      transformOrigin: "111.993px 380.742px"
    },
    className: "animable",
    id: "el56ja790hs6k"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.55 338.21c6-1.2 14.73 0 19.36 4.79s5.11 10.79 3.94 13.92-3-4.61-7.81-8.18-7-3.19-2.91.59 9.52 10.79 10.44 15.35-3.22 9.8-4.6 9.49.08-5.05-2.33-11.62-7-10.8-10.49-11.73-2.59.2 2.17 5.24 10.43 15.41 8.45 20.48-7 6.91-8.31 6.5 1.75-6.78-1.08-14.83-8.5-13.61-11.38-11.74-.6 4 2.4 10 7.1 18 5.9 21.92-8.39 6.77-9.51 5.59 2-7.89 0-16.36-5.67-11.69-5.91-8.18 5 19.91 3.75 22.75-14.34 7.61-14.34 7.61-7.13-8.3-7.61-10.84 5.28-13.07 8.53-16.12-1-3.19-3.58-1.1-8.35 9.78-8.7 13.68c-3.57-3.84-6.79-8.74-3.86-12.09s11.82-9 17.08-11.1 9-7.44 2-5.81-19 8.56-21 13.59c-1-4.41-.29-16.88 7.37-19.2s15.77-2 18.15-2.93-.82-2.88-6.67-3.04-13.63.53-16.51 4.44c0-4.88.48-9.79 9.44-10.19s12.93 3.13 14.31 2.08-5.77-4.53-11-4.65c3.43-4.31 7.78-5.54 12.7-4.63a20.69 20.69 0 0 1 11.61 6.32Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "53.5924px 365.704px"
    },
    id: "elv03rjf20i0k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91 316.31c1.57-4.41 8-6.14 11.18-4.88-3.31.95-6 3.73-4.18 2.84 3.86-1.86 6.29-2.72 10.86-2a7.71 7.71 0 0 1 5.93 4.79 27.65 27.65 0 0 0-9.33-.94c-1.5.14-5.46.92-.56.75 7.7-.27 10.67 2.4 10.67 2.4s2.68 2.52 3 5.51c-4.18-4.17-10.76-4.65-13.2-4.81s-4.6 1.19-.59 1.35 11.44 2.68 13.81 6.68.94 10.24.94 10.24-9.45-12.13-12.76-10.55c0 1.89 9.77 7.87 11.5 11.34s-1.57 10.87-1.57 10.87-8.88-.31-11.21-1.73-1.8-11.12-3.06-12.54-4.32 6.08-2.59 12.38c0 0-4.41.79-5.36-2.68s.48-10.71 2.37-14-1.26-2.52-2.84 0-3.6 8.05-3 11.66c0 0-5.2-2.21-6.62-4.88s3.15-10.09 5.52-12 .15-3.31-2.21-1.42-6.14 7.57-6.46 10.4c-2.81-4.86-3.26-11.16 1-15.88 4.54-5.03 8.76-2.9 8.76-2.9Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "99.5212px 330.464px"
    },
    id: "elpqc5pr4s97o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91 316.31c1.57-4.41 8-6.14 11.18-4.88-3.31.95-6 3.73-4.18 2.84 3.86-1.86 6.29-2.72 10.86-2a7.71 7.71 0 0 1 5.93 4.79 27.65 27.65 0 0 0-9.33-.94c-1.5.14-5.46.92-.56.75 7.7-.27 10.67 2.4 10.67 2.4s2.68 2.52 3 5.51c-4.18-4.17-10.76-4.65-13.2-4.81s-4.6 1.19-.59 1.35 11.44 2.68 13.81 6.68.94 10.24.94 10.24-9.45-12.13-12.76-10.55c0 1.89 9.77 7.87 11.5 11.34s-1.57 10.87-1.57 10.87-8.88-.31-11.21-1.73-1.8-11.12-3.06-12.54-4.32 6.08-2.59 12.38c0 0-4.41.79-5.36-2.68s.48-10.71 2.37-14-1.26-2.52-2.84 0-3.6 8.05-3 11.66c0 0-5.2-2.21-6.62-4.88s3.15-10.09 5.52-12 .15-3.31-2.21-1.42-6.14 7.57-6.46 10.4c-2.81-4.86-3.26-11.16 1-15.88 4.54-5.03 8.76-2.9 8.76-2.9Z",
    style: {
      opacity: 0.35,
      transformOrigin: "99.5212px 330.464px"
    },
    className: "animable",
    id: "el0oxp4w8g06ho"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Dog--inject-56",
    className: "animable",
    style: {
      transformOrigin: "214.541px 367.799px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--dog--inject-56",
    className: "animable",
    style: {
      transformOrigin: "214.541px 367.799px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M167.56 393.44A26.37 26.37 0 0 1 166 391a25 25 0 0 1-3-14.76c.14-1.37.38-2.74.63-4.1.09-.51.46-2.83-.82-2a1.36 1.36 0 0 0-.44.61 36 36 0 0 0-3.37 11.66 22.6 22.6 0 0 0 .47 6.91c1.62 6.91 7.22 12.49 13.36 15.62.56.28 1.11.54 1.68.79a4.12 4.12 0 0 0 2 .47c1-.12 1.36-1.13 1.94-1.79a1.44 1.44 0 0 0-.08-2.27 5.44 5.44 0 0 0-1.47-.87 25.12 25.12 0 0 1-9.34-7.83Z",
    style: {
      fill: "#263238",
      transformOrigin: "168.941px 388.082px"
    },
    id: "elg068k859i6m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.49 365c2.2 3.94 7 12.89 6.81 19.18s-6.21 9.78-6.21 9.78l-11.28-4.34Z",
    style: {
      fill: "#263238",
      transformOrigin: "244.558px 379.48px"
    },
    id: "el80ejtuwfmo7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.39 386.81c9 .25 11.69.74 13.8 4.1s-4.65 9.32-4.65 9.32 5-1.11 7.38 0 1.32 4.59-7.38 7.09a120.72 120.72 0 0 1-17 3.48s-12.58-9.65-5-18.68 12.85-5.31 12.85-5.31Z",
    style: {
      fill: "#263238",
      transformOrigin: "215.566px 398.425px"
    },
    id: "eldyzb95xzuu6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.7 385.49a27.91 27.91 0 0 1 10.62-15.44c12.68-8.93 27.82-15.64 40.41-6.19.38.83.67 1.65 1.08 2.47a8.25 8.25 0 0 1 .92 2.76 2.37 2.37 0 0 1-.32 1.69 1.16 1.16 0 0 1-1.54.36 10 10 0 0 1 .61 2.37 4.59 4.59 0 0 1-.42 2.73 1.76 1.76 0 0 1-2.21.55 24.8 24.8 0 0 1-.57 3 13.7 13.7 0 0 1-1.3 2.93 12.35 12.35 0 0 1-4.12 4.2c-2.25 1.49-11.05 3.65-14.09 3.94a69.75 69.75 0 0 1-9.14.3 8.34 8.34 0 0 0-4 .49c-1.22.61-2 1.8-3.07 2.68-2 1.66-4.72 2.08-7.31 2.26a7.81 7.81 0 0 1-4.57-.65 4.33 4.33 0 0 1-2-4.16 41.29 41.29 0 0 1 1.02-6.29Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "221.711px 377.983px"
    },
    id: "elpg4fpklmm0q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m196.68 389.32-1.94 2c0 .16 0 .32-.05.47a4.33 4.33 0 0 0 2 4.16 7.81 7.81 0 0 0 4.57.65c2.59-.18 5.32-.6 7.31-2.26 1-.88 1.85-2.07 3.07-2.68a6.88 6.88 0 0 1 3.22-.51c-6.27-4.52-18.18-1.83-18.18-1.83Z",
    style: {
      fill: "#263238",
      transformOrigin: "204.761px 392.612px"
    },
    id: "elknf2bvv7yr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.62 400.77c-2.79-2.79-11-7.13-18.28-10s-9-4.43-11.81-9.79c-2.52-4.74-2.2-11.25-2.13-15.94 0-.64 0-1.21.07-1.74 4.15 1.3 8.83 1.06 12.25-1.06l-20.3-10.47c-3.13 3.46-21.06 4.08-30.52 7.8-8.94 3.51-21.11 12.76-23.27 23.47-1.66 8.24-1.9 21.39 9.55 29.7 12.69 9.21 37.09.89 40.19-.34 4.8-1.91 6.82-4.37 6-6s-3.86-2.16-7-1.57a56.82 56.82 0 0 0-7.77 2.35c9.43-7.08 8.78-12.85 5.28-15.28-6.48-4.5-19.4.75-19.4.75a18.36 18.36 0 0 1 2.74-7.28c1.57-2.35 7.12-6.57 11.65-4.79s6.25 6.32 12 12 19.56 8.54 22.9 9a16.06 16.06 0 0 1 8.21 3.65c2 1.74 3.41 4 5.65 4.75 1.85.59 2.94-1.3 2.94-1.3 3 .76 3.13-1.81 3.13-1.81 1.24-1.35.51-3.49-2.08-6.1Z",
    style: {
      fill: "#455a64",
      transformOrigin: "219.542px 384.397px"
    },
    id: "el53qdrp4qt6v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.43 366.27c5.85 2.05 11.15.93 13.2-.32l-.9-2.09C229.35 367 224.34 353 224.34 353a15.38 15.38 0 0 0 10.09 13.27Z",
    style: {
      opacity: 0.1,
      transformOrigin: "235.985px 360.201px"
    },
    className: "animable",
    id: "el02ef1v472r0n"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.6 318.6c-1.8-.41-5.2 4.13-7.13 10.41l8.95 2a9 9 0 0 1-2.78-5.14 18.52 18.52 0 0 1 .96-7.27Z",
    style: {
      fill: "#455a64",
      transformOrigin: "247.945px 324.792px"
    },
    id: "eltjjz0qn00f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.58 328.9c.91-4.85 3-9.21 4.66-10.24s.56 7.42 2.18 12.33Z",
    style: {
      fill: "#263238",
      transformOrigin: "249px 324.782px"
    },
    id: "elupg72nsf1w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.45 348.29c-.76-1.61-3.26-2-6.51-4.47s-4.23-5.59-7-9.4-7.4-6.8-14.82-5c-3.49.86-7.56 1.28-11.07 6.67-1.74 2.66-.56 3.4-2.38 10.34a22.88 22.88 0 0 1-1.55 4.09c3.76 9.37 10.27 14.52 19.9 11.69l.74-.92a14.79 14.79 0 0 1 1.91-2.56 8.07 8.07 0 0 1 7.06-2c6.41 1 9.55 0 11.82-1.71a6 6 0 0 0 1.9-6.73Z",
    style: {
      fill: "#455a64",
      transformOrigin: "247.964px 345.934px"
    },
    id: "el6z2b8dusl55",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244 338.73a4.23 4.23 0 0 0-.77 1.68c-.05.3 0 .68.25.8s.6-.15.83-.39a6.48 6.48 0 0 1 1.95-1.46c.88-.38 2.07-.63 1.42-1.68-.38-.61-1.37-.56-2-.33a3.73 3.73 0 0 0-1.68 1.38Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "245.539px 339.215px"
    },
    id: "elrydlhhv4ezl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.84 357c6.65 1 9.41-.2 11.68-1.94a6 6 0 0 0 1.93-6.74c-.76-1.61-3.26-2-6.51-4.47-1.43-1.07-2.67-2.13-4-3.29-1.61-1.37-3-2.81-4.75-4.45-.56-.52-1.52-1.49-1.91-1.24s.41 1.15.81 1.63a23.58 23.58 0 0 1 2.29 3.23 4.2 4.2 0 0 1 .57 2.8 7.45 7.45 0 0 1-3.08 4.85 7.19 7.19 0 0 0-3.24 4.58c-.71 2.45.14 4.75 1.1 5.46a9.58 9.58 0 0 1 5.11-.42Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "259.585px 346.125px"
    },
    id: "elbqgp200jctg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.55 354a1.22 1.22 0 0 0-.38-.07c-.4 0-.67.33-1 .55a6.66 6.66 0 0 1-2.9 1.12 10.87 10.87 0 0 1-6.12-1.08s-.05.07 0 .08a8.17 8.17 0 0 0 6 1.68 7.43 7.43 0 0 0 2.9-.93c.18-.1.35-.21.52-.32a5.59 5.59 0 0 0 .98-1.03Z",
    style: {
      opacity: 0.2,
      transformOrigin: "263.339px 355.133px"
    },
    className: "animable",
    id: "el3gnoq5dajky"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.15 347.09c-3.07.35-4.86 1.92-5.11 2.41-.47 1 1.25 2.2 2.37 2.47.66.16 2.57-.75 3.14-1.23.9-.74.85-3.45-.4-3.65Z",
    style: {
      fill: "#263238",
      transformOrigin: "267.063px 349.539px"
    },
    id: "elunzquo1mru9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.65 342.11c.32.82-.35 1.08-1.17 1.4s-1.48.58-1.8-.24a1.59 1.59 0 1 1 3-1.16Z",
    style: {
      fill: "#263238",
      transformOrigin: "248.151px 342.448px"
    },
    id: "elrx9oflhk87",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.48 324.35c-1.49.13-2.11 3.31-2.87 7.08s-1.3 9.25-.54 11.2 3.53 1.7 3.53 1.7a41.51 41.51 0 0 1-.47-10.35 78.22 78.22 0 0 0 .35-9.63Z",
    style: {
      fill: "#455a64",
      transformOrigin: "230.652px 334.345px"
    },
    id: "elg0wdk05cd3p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.6 344.33c-1.71-4.35-1.49-16.12-.59-19.34s3.81 6.91 6.4 8.88c-2.52 1.13-5.87 4.55-5.81 10.46Z",
    style: {
      fill: "#263238",
      transformOrigin: "234.866px 334.346px"
    },
    id: "elpxaifizlce",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.73 361.31c-3.45 2.07-10.58 1.65-14.4-1.64a16.43 16.43 0 0 1-6-9.72 6.69 6.69 0 0 0-1.75 2.79c.37 2.27.87 4 4 7.41 4.09 4.37 13 6.92 18.06 3.71a5.84 5.84 0 0 0 .09-2.55Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "235.705px 357.626px"
    },
    id: "elxww8ntsn70c",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-56",
    className: "animable animator-active",
    style: {
      transformOrigin: "314.987px 277.493px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) slideRight",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-56",
    className: "animable",
    style: {
      transformOrigin: "314.987px 277.493px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bottom--inject-56",
    className: "animable",
    style: {
      transformOrigin: "344.18px 334.444px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M318 398.13c.51-9.89 2.19-56.71 2.19-56.71l20 12.74c-.91 20.54-6.31 47.51-6.31 47.51s-7.94 7.24-12.15 11.4a87.31 87.31 0 0 1-11.5 9.93c-3.17 2.15-10 3.22-11.18 1.15 5.11-5.1 11.07-10.71 14.93-16.27 1.85-2.66 3.77-4.12 4.02-9.75Z",
    style: {
      fill: "#ffa8a7",
      transformOrigin: "319.62px 383.341px"
    },
    id: "elrde3a7w6mwf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.84 428.63c-.3 0-.48 3.29 1.22 4.53 2 1.44 7.57 3.61 14.62 2.12s10.74-4 13.41-6.62 6.39-6.3 9.56-7.27c2.94-.9 6.08-2.52 7-3.52s.42-5.11.42-5.11Z",
    style: {
      fill: "#263238",
      transformOrigin: "311.925px 424.271px"
    },
    id: "el9amff013m5e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.41 399.18a3.91 3.91 0 0 1 .36 1.76c-.06 1.52-.79 3-.34 5.56a30.55 30.55 0 0 1 .59 7.69c-.22 2.14-5 4-8 5.43a40 40 0 0 0-9.6 7.2c-3.13 3-9.95 6.36-14.59 6.8-7.09.67-11.84-.89-13.46-3.32-2-3 .95-6.8 6.53-9.93 1.48-.84 7.2-4.31 8.95-5.62 4.75-3.54 8.56-7.94 10.41-13.69a3.17 3.17 0 0 1 1.06-1.8 5.72 5.72 0 0 1 2.34-.27 13.45 13.45 0 0 1 4 .87c1.14.43 3.4.89 3.49 2.29a7.06 7.06 0 0 1-.39 1.91c-.07.3-.28 1.33 0 1.48s.85-.58 1-.81c.84-1.07 1.1-1.71 2.23-2s4.37-.77 5.11-2Z",
    style: {
      fill: "#37474f",
      transformOrigin: "311.901px 416.371px"
    },
    id: "el6umamlv9uus",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.88 420.37c10.32-.12 13.35 7.24 14.1 11.13a24.24 24.24 0 0 1-7.17 2.12c-7.09.67-12.13-.86-13.75-3.3-1.89-2.84-.73-7.2 6.82-9.95Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "299.121px 427.073px"
    },
    id: "el4dq117sngbt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.29 420a.55.55 0 0 0 .31-.14.5.5 0 0 0 0-.71 12.12 12.12 0 0 0-9.58-2.92.51.51 0 0 0-.4.59.5.5 0 0 0 .59.4 11.23 11.23 0 0 1 8.67 2.63.49.49 0 0 0 .41.15Z",
    style: {
      fill: "#f0f0f0",
      transformOrigin: "305.68px 418.065px"
    },
    id: "elelknwi55ia",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.58 417.05a.48.48 0 0 0 .31-.13.52.52 0 0 0 0-.72 12.12 12.12 0 0 0-9.58-2.92.51.51 0 0 0-.4.59.49.49 0 0 0 .59.4 11.19 11.19 0 0 1 8.66 2.63.46.46 0 0 0 .42.15Z",
    style: {
      fill: "#f0f0f0",
      transformOrigin: "309.968px 415.117px"
    },
    id: "elxvpdl0f30rg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.3 413.74a.55.55 0 0 0 .31-.14.5.5 0 0 0 0-.71A12.1 12.1 0 0 0 309 410a.5.5 0 0 0 .19 1 11.23 11.23 0 0 1 8.66 2.62.5.5 0 0 0 .45.12Z",
    style: {
      fill: "#f0f0f0",
      transformOrigin: "313.672px 411.821px"
    },
    id: "eli3zsnnxb55",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322 410.28a.53.53 0 0 0 .31-.13.5.5 0 0 0 0-.71c-2.16-2.33-6.74-3.61-10.43-2.91a.5.5 0 1 0 .18 1c3.33-.63 7.59.54 9.52 2.6a.48.48 0 0 0 .42.15Z",
    style: {
      fill: "#f0f0f0",
      transformOrigin: "316.958px 408.312px"
    },
    id: "el2e7uwj2yrm3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m371.25 365.65 21.8-2.3c.94 14.6 0 31 .84 44.68.15 2.58 1.8 20 1.29 25.37-.76 8.08-10.3 7.82-11.22 3.11s-3-25.29-3.22-27.38c-.67-8.78-4.64-23.09-8.16-38.64-.17-.76-1.16-4.1-1.33-4.84Z",
    style: {
      fill: "#ffa8a7",
      transformOrigin: "383.264px 401.581px"
    },
    id: "elmxncwwo5yxf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.69 440.13c.21 4.69.9 7.81 2.53 10.58s4.75 3.68 7.94 2.92 7.29-2.86 8.25-6.89.82-6.81.16-11.17Z",
    style: {
      fill: "#263238",
      transformOrigin: "390.394px 444.729px"
    },
    id: "el1vne8gt27cr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.8 406.35c1.31.12 1.61 6.42 2.28 12.74.72 6.76 2.7 9.58 3.34 15.13.74 6.34.37 9.16-1.89 13s-10.17 7.45-14 1.91c-3.09-4.51-3.16-9.46-2.78-15.78a141.83 141.83 0 0 0-.21-16c-.19-4.74-1.17-9.53 0-10 .08.69.15 1.58.24 2.26s.16 3.1.89 3.13a9.7 9.7 0 0 0 0-1.79 2.07 2.07 0 0 1 .38-1.52 2.43 2.43 0 0 1 1.46-.63c1.29-.24 4-.31 5.34-.41a18.25 18.25 0 0 1 2-.06 5.13 5.13 0 0 1 1.65.26 1.16 1.16 0 0 1 .7.65 1.75 1.75 0 0 1 .06.72 5.79 5.79 0 0 0 .15 1.31c0 .18.17.41.36.37s.21-.22.22-.38c0-.76-.08-1.32-.1-2.21 0-.41-.07-1-.07-1.38s0-.91-.02-1.32Z",
    style: {
      fill: "#37474f",
      transformOrigin: "389.87px 429.162px"
    },
    id: "elve0wa0hlx1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.74 437.89c.17 3.94-.09 6.63-1.87 9.6-2.26 3.79-10.8 7.45-14.59 1.91-1.89-2.75-2.36-6-2.58-9.27 2.37-4.2 15.43-5.88 19.04-2.24Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "390.242px 444.061px"
    },
    id: "elkl25h7p4tig",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.15 433.29a.47.47 0 0 0 .16 0 19 19 0 0 1 11.31-1 .49.49 0 0 0 .23-.95 19.8 19.8 0 0 0-12 1.08.48.48 0 0 0 .25.92Z",
    style: {
      fill: "#f0f0f0",
      transformOrigin: "389.87px 432.105px"
    },
    id: "eljuz7njsu8lm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.37 427.51a.46.46 0 0 0 .41-.32.49.49 0 0 0-.29-.62c-5.85-2.06-11.69.84-11.93 1a.48.48 0 0 0-.22.65.5.5 0 0 0 .66.21c.05 0 5.73-2.84 11.16-.91a.5.5 0 0 0 .21-.01Z",
    style: {
      fill: "#f0f0f0",
      transformOrigin: "389.548px 427.158px"
    },
    id: "el8bybh83aggm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.09 423.06a.46.46 0 0 0 .41-.31.49.49 0 0 0-.28-.63 15 15 0 0 0-12.17.93.48.48 0 1 0 .49.83 14.36 14.36 0 0 1 11.34-.85.39.39 0 0 0 .21.03Z",
    style: {
      fill: "#f0f0f0",
      transformOrigin: "389.172px 422.597px"
    },
    id: "elcd8r00svsjt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.76 418.06a.47.47 0 0 0 .41-.31.49.49 0 0 0-.28-.63c-6-2.34-12 .92-12.25 1.06a.48.48 0 0 0-.19.66.47.47 0 0 0 .66.19c.06 0 5.84-3.18 11.43-1a.42.42 0 0 0 .22.03Z",
    style: {
      fill: "#ebebeb",
      transformOrigin: "388.795px 417.687px"
    },
    id: "elimcr22rz8p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.68 215c6.59 9.51 16.49 22.6 16.19 47-.47 38.4-1.52 57-1.52 57 1.62 4.2 4.52 7.17 4.65 26.45.09 15.39-.62 36.92-.62 36.92s-10.6 5.09-19.6 1.29c-3.44-12.53-8.67-45.3-12.38-62.06-3.37-15.22-6-34.06-6-34.06l-10.3 36.23a89.54 89.54 0 0 1-.82 24.23c-1.77 10.18-7.91 35.49-7.91 35.49s-10.73 4.52-19.09-.11c0 0 .34-51.92.76-64.34.63-18.63.22-49.79 3.27-75.25 1.17-9.73 4.53-19.73 6.16-26.26Z",
    style: {
      fill: "#37474f",
      transformOrigin: "356.644px 300.233px"
    },
    id: "el4r3boh3b1ci",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.91 378.66c-3.72 2.26-16.44 3.89-21.44 1.95l1.34 5.92s3.26 1.37 10.18 1.07 9.66-3.14 9.66-3.14Z",
    style: {
      fill: "#455a64",
      transformOrigin: "384.19px 383.151px"
    },
    id: "el3dnmz6belp7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.1 378c-6.38 2.61-16.22 2.7-20.79-.82v6.08s1.89 2.61 8.82 2.8c8.26.22 10.47-1.61 10.47-1.61Z",
    style: {
      fill: "#455a64",
      transformOrigin: "328.705px 381.629px"
    },
    id: "eljad9psli3p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.42 287.46 352 256.87s-16.15-2.14-22-7.87c0 0 7.28 10.57 18.24 12.42l4.33 22.58-6.4 39.41Z",
    style: {
      fill: "#263238",
      transformOrigin: "343.21px 286.205px"
    },
    id: "elcszesgut2v",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Top--inject-56",
    className: "animable",
    style: {
      transformOrigin: "314.987px 177.984px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M295.57 203.41c4.47-1.7 22.69-11 28-13.68 6.66-3.38 13.19-7 13.19-7s7.82-22.33 1.55-22a29.23 29.23 0 0 0-14.47 4c-7.74 4.73-18.42 12-22.59 14.48-4.8 2.9-9 6.17-14 8.84 0 0-32.28 1.15-37.43-1.24s-1.7 12.46-1.7 12.46c2-.72 6.74.24 9.34.73l12.74 2.38c5.51 1 9.25 1.71 12.87 2.36 6.38 1.11 8.03.37 12.5-1.33Z",
    style: {
      fill: "#ffa8a7",
      transformOrigin: "293.867px 182.996px"
    },
    id: "elofnyxkgpo2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.32 196.56a7.55 7.55 0 0 0 1.19 2.43c.54.63 1.75.76 2.52.93 1.33.3 3.74.63 4.48-.34a.54.54 0 0 0 .05-.52h.77a1.65 1.65 0 0 0 1.35-.62s1.14.53 1.62.69c1.16.37 3.33 2.21 6 1.57a11.65 11.65 0 0 0 4.11-1.71L245 196.2l-6.19-5.06-2.81-2.32a5.56 5.56 0 0 0-1.23-1 8.93 8.93 0 0 0-1.54-.4 6.35 6.35 0 0 0-2.34 0c-1.2.26-2.2 1.42-3.06 2.26a12.51 12.51 0 0 0-2.25 2.67c-.5.9.11 2.14.38 3 .1.36.22.78.36 1.21Z",
    style: {
      fill: "#f28f8f",
      transformOrigin: "236.9px 194.073px"
    },
    id: "eljigbw5qt8tg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.84 188.51a56.93 56.93 0 0 1-11.45-4.79c-3.85-2-5.08-2.79-7.36-2.17-1.39.38-2.7 1-4.05 1.49-1.16.44-2.37.71-3.55 1.09-.82.26-1.64.58-2.45.92-1.15.48-2.26 1.13-3.4 1.63-1.54.67-3.13 1.17-4.67 1.91a16.41 16.41 0 0 0-3.68 1.89c-.84.74.28 1.46 1 1.75 2.37 1 4.95-.58 7.22-1.18 1.13-.3 2.28-.46 3.41-.8.83-.25 1.85-.64 2.56-.85h1.73a22.69 22.69 0 0 0 2.85-.57v.11a1 1 0 0 1-.31.94 10.07 10.07 0 0 1-2.82 1.85c-1.56.63-2.19 1-3.81 1.56a21.26 21.26 0 0 0-4.2 1.65c-.9.63-1.44 2 .32 3a6.19 6.19 0 0 0 5.05.28c1.58-.46 4.67-2.09 5.64-2.35a3.28 3.28 0 0 1 3.1.62c1.28.9 3.37 3.17 7.27 3.39s5.42-1.41 8.82-.8Z",
    style: {
      fill: "#ffa8a7",
      transformOrigin: "234.385px 190.622px"
    },
    id: "el62ntflokvdg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233 188.84a11.34 11.34 0 0 1 .06-4.12 6.12 6.12 0 0 0-.51 4.32Z",
    style: {
      fill: "#f28f8f",
      transformOrigin: "232.713px 186.88px"
    },
    id: "eleg90f4pedq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.39 159.85s11 .43 19.7 1.77l4.3.35c2.58 1.11 10.54 9.07 10.14 25.08-.26 10 2.37 33.21 2.37 33.21-13.48 10.68-52.11 10.5-62 .91 0 0 2.68-14.66 3.13-21.94 0 0-4.55-6.3-4.31-10.87.35-6.71.89-8.61 6.88-16.22 5.69-7.25 9.68-11.46 9.68-11.46Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "353.305px 194.084px"
    },
    id: "el9562kcm2nu4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m343.56 141.34 6.41 3.59 13.49 7.56c.23-5.64 9.11-7.36 12.25-20.63 1.63-6.87-.41-19-7.85-19.65-1.89-6.07-8-9.3-13.89-10.47a28.27 28.27 0 0 0-17 1.59c-4.42 2-9.73 5-11.56 9.68a6.1 6.1 0 0 0 0 4.17c.36 1.14 1.52 2 1.67 3.16s-1.59 2.06-2.47 2.78c-1.56 1.27-3.22 2.81-2.72 5.06.39 1.75 2.46 3 4 2.45a1.34 1.34 0 0 1-1.35-1.26c-.16-1.25.95-2 2-2.2 1.74-.29 4.45.51 5.63-1.24.77.27 1.72 0 2.6.64a7.48 7.48 0 0 1 2.55 5.77 14.18 14.18 0 0 0 .81 4.47c.95 2.34 3.4 3.39 5.43 4.53Z",
    style: {
      fill: "#455a64",
      transformOrigin: "349.017px 126.794px"
    },
    id: "el4f5tp1jgy1k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m363.25 157.78.5-12.25a5.35 5.35 0 0 0 6.55-1.44c3.58-3.86 3.86-8 1.81-10.62s-6.51-1.82-8.74 1.27a1.67 1.67 0 0 1-1.72.69c-2.2-.56-2.9-4.43-.92-8.44 0 0-6.56-3.64-5.47-10.49-5.42 3.55-18.16 5.43-21.33-.21-1.72 2.7-4.09 5.87-3.77 20.26.3 13.15 4.44 16.4 8 17.91a15.2 15.2 0 0 0 7.38.6l-.16 3.27c0 1.7-.36 1.8-1.84 1.91l-.73.06s-5.12 7 3.64 7.8c15.82 1.47 21.59-6.48 21.59-6.48s-1.15-.17-1.83-.25c-2.66-.37-2.69-1.3-2.96-3.59Z",
    style: {
      fill: "#ffa8a7",
      transformOrigin: "351.76px 142.286px"
    },
    id: "elc142awdiro9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m348.77 143.1-5.65 2a2.94 2.94 0 0 0 3.75 1.95 3.13 3.13 0 0 0 1.9-3.95Z",
    style: {
      fill: "#b16668",
      transformOrigin: "346.028px 145.151px"
    },
    id: "el0q7dytl300xi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.44 144.42a3.3 3.3 0 0 0-3.23 2.64 2.86 2.86 0 0 0 1.66-.06 3.06 3.06 0 0 0 2-2.53 3.29 3.29 0 0 0-.43-.05Z",
    style: {
      fill: "#f28f8f",
      transformOrigin: "347.04px 145.788px"
    },
    id: "el7u9gvexrg8n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m332 129.36 4.15-2a2.19 2.19 0 0 0-3-1.15 2.41 2.41 0 0 0-1.15 3.15Z",
    style: {
      fill: "#263238",
      transformOrigin: "333.971px 127.672px"
    },
    id: "el4f9680v5frs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m352.2 129.42-4.13-2.14a2.24 2.24 0 0 1 3.07-1 2.45 2.45 0 0 1 1.06 3.14Z",
    style: {
      fill: "#263238",
      transformOrigin: "350.24px 127.718px"
    },
    id: "el3sym8ofqy0d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f28f8f",
      transformOrigin: "339px 135.82px"
    },
    id: "elxxy8jvh40n",
    className: "animable",
    d: "m342.3 129.78-.34 12.08-6.26-2.41 6.6-9.67z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.05 132a2 2 0 0 1-1.71 2.12 1.84 1.84 0 0 1-2.09-1.64 2 2 0 0 1 1.75-2.08 1.84 1.84 0 0 1 2.05 1.6Z",
    style: {
      fill: "#263238",
      transformOrigin: "335.151px 132.262px"
    },
    id: "elz0o6dhfmkle",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.92 132.05a2 2 0 0 1-1.71 2.12 1.84 1.84 0 0 1-2.09-1.64 2 2 0 0 1 1.71-2.12 1.84 1.84 0 0 1 2.09 1.64Z",
    style: {
      fill: "#263238",
      transformOrigin: "349.02px 132.29px"
    },
    id: "elyrheq8bvpnr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.59 155.06c7.25-.91 13.66-3.8 15.66-7.92 0 0-1 4.48-3.9 6.28-4.08 2.53-11.9 4.08-11.9 4.08Z",
    style: {
      fill: "#f28f8f",
      transformOrigin: "353.35px 152.32px"
    },
    id: "elr5ib0huei2r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.39 162c3.62.24 13.58.37 19.44 7.76 6.36 8 15.55 23.85 21.19 34.79 3.38 6.57 4.22 10.57 1 15.39-2.86 4.22-16.33 19.64-20.17 24.06-2.55 2.94-5.93 8.53-8.63 10.87 0 0-5.92-.73-10-10.87 0 0-.39-1.54-4 .14-2.5 1.17-5.77 1.7-7.49.36s1.84-2.52 3.58-3.86a22.32 22.32 0 0 1 8.59-4.63c4.52-1.25 6.12.31 10.11-4.71s10.17-18.87 10.17-18.87L380 188.11c-5.23-8.49-10.55-17.6-7.61-26.11Z",
    style: {
      fill: "#ffa8a7",
      transformOrigin: "389.658px 208.435px"
    },
    id: "eltsvnu60k2g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.16 212.4c2.51-4.11 8.69-5 8.69-5a11.87 11.87 0 0 0-9.68 3.41Z",
    style: {
      fill: "#f28f8f",
      transformOrigin: "400.01px 209.865px"
    },
    id: "elswpv8074bsl",
    className: "animable"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "active",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#32DFEC",
    floodOpacity: 1,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "hover",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "red",
    floodOpacity: 0.5,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 1 0 0 0 0 0 0 0 0 0 0 0 1 0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnprocessableEntity);
export default __webpack_public_path__ + "static/media/unprocessableEntity.467b56afa04e03cbafe8b3dc4e7f2cc3.svg";
export { ForwardRef as ReactComponent };